webpackJsonp([4],{

/***/ 1302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteModalTrigger = function (_React$PureComponent) {
    (0, _inherits3.default)(DeleteModalTrigger, _React$PureComponent);

    function DeleteModalTrigger(props) {
        (0, _classCallCheck3.default)(this, DeleteModalTrigger);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeleteModalTrigger.__proto__ || (0, _getPrototypeOf2.default)(DeleteModalTrigger)).call(this, props));

        _this.handleOpenModal = function (e) {
            e.preventDefault();

            _this.setState({
                showDeleteModal: true
            });
        };

        _this.handleConfirm = function () {
            _this.props.onDelete();
        };

        _this.handleCancel = function () {
            _this.setState({
                showDeleteModal: false
            });
        };

        _this.handleKeyDown = function (e) {
            if (Utils.isKeyPressed(e, _constants2.default.KeyCodes.ENTER)) {
                _this.handleConfirm(e);
            }
        };

        if (_this.constructor === DeleteModalTrigger) {
            throw new TypeError('Can not construct abstract class.');
        }

        _this.state = {
            showDeleteModal: false
        };
        return _this;
    }

    (0, _createClass3.default)(DeleteModalTrigger, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: 'color--link style--none',
                        onClick: this.handleOpenModal
                    },
                    this.triggerTitle
                ),
                _react2.default.createElement(_confirm_modal2.default, {
                    show: this.state.showDeleteModal,
                    title: this.modalTitle,
                    message: this.modalMessage,
                    confirmButtonText: this.modalConfirmButton,
                    onConfirm: this.handleConfirm,
                    onCancel: this.handleCancel,
                    onKeyDown: this.handleKeyDown
                })
            );
        }
    }]);
    return DeleteModalTrigger;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DeleteModalTrigger.propTypes = {
    onDelete: _propTypes2.default.func.isRequired
};
exports.default = DeleteModalTrigger;

/***/ }),

/***/ 1303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

var _channel_select = __webpack_require__(1304);

var _channel_select2 = _interopRequireDefault(_channel_select);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _spinner_button = __webpack_require__(926);

var _spinner_button2 = _interopRequireDefault(_spinner_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AbstractIncomingWebhook = function (_React$Component) {
    (0, _inherits3.default)(AbstractIncomingWebhook, _React$Component);

    function AbstractIncomingWebhook(props) {
        (0, _classCallCheck3.default)(this, AbstractIncomingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractIncomingWebhook.__proto__ || (0, _getPrototypeOf2.default)(AbstractIncomingWebhook)).call(this, props));

        _this.getStateFromHook = function (hook) {
            return {
                displayName: hook.display_name || '',
                description: hook.description || '',
                channelId: hook.channel_id || '',
                username: hook.username || '',
                iconURL: hook.icon_url || '',
                saving: false,
                serverError: '',
                clientError: null
            };
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            if (_this.state.saving) {
                return;
            }

            _this.setState({
                saving: true,
                serverError: '',
                clientError: ''
            });

            if (!_this.state.channelId) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_incoming_webhook.channelRequired',
                        defaultMessage: 'A valid channel is required'
                    })
                });

                return;
            }

            var hook = {
                channel_id: _this.state.channelId,
                display_name: _this.state.displayName,
                description: _this.state.description,
                username: _this.state.username,
                icon_url: _this.state.iconURL
            };

            _this.props.action(hook).then(function () {
                return _this.setState({ saving: false });
            });
        };

        _this.updateDisplayName = function (e) {
            _this.setState({
                displayName: e.target.value
            });
        };

        _this.updateDescription = function (e) {
            _this.setState({
                description: e.target.value
            });
        };

        _this.updateChannelId = function (e) {
            _this.setState({
                channelId: e.target.value
            });
        };

        _this.updateUsername = function (e) {
            _this.setState({
                username: e.target.value
            });
        };

        _this.updateIconURL = function (e) {
            _this.setState({
                iconURL: e.target.value
            });
        };

        _this.state = _this.getStateFromHook(_this.props.initialHook || {});
        return _this;
    }

    (0, _createClass3.default)(AbstractIncomingWebhook, [{
        key: 'render',
        value: function render() {
            var headerToRender = this.props.header;
            var footerToRender = this.props.footer;

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/incoming_webhooks' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_incoming_webhooks.header',
                            defaultMessage: 'Incoming Webhooks'
                        })
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: headerToRender.id,
                        defaultMessage: headerToRender.defaultMessage
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form' },
                    _react2.default.createElement(
                        'form',
                        {
                            className: 'form-horizontal',
                            onSubmit: this.handleSubmit
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'displayName'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.displayName',
                                    defaultMessage: 'Title'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'displayName',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.displayName,
                                    onChange: this.updateDisplayName
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_incoming_webhook.displayName.help',
                                        defaultMessage: 'Choose a title to be displayed on the webhook settings page. Maximum 64 characters.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'description'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.description',
                                    defaultMessage: 'Description'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'description',
                                    type: 'text',
                                    maxLength: '128',
                                    className: 'form-control',
                                    value: this.state.description,
                                    onChange: this.updateDescription
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_incoming_webhook.description.help',
                                        defaultMessage: 'Description for your incoming webhook.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'channelId'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.channel',
                                    defaultMessage: 'Channel'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(_channel_select2.default, {
                                    id: 'channelId',
                                    value: this.state.channelId,
                                    onChange: this.updateChannelId,
                                    selectOpen: true,
                                    selectPrivate: true
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_incoming_webhook.channel.help',
                                        defaultMessage: 'Public or private channel that receives the webhook payloads. You must belong to the private channel when setting up the webhook.'
                                    })
                                )
                            )
                        ),
                        this.props.enablePostUsernameOverride && _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'username'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.username',
                                    defaultMessage: 'Username'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'username',
                                    type: 'text',
                                    maxLength: '22',
                                    className: 'form-control',
                                    value: this.state.username,
                                    onChange: this.updateUsername
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_incoming_webhook.username.help',
                                        defaultMessage: 'Choose the username this integration will post as. Usernames can be up to 22 characters, and may contain lowercase letters, numbers and the symbols "-", "_", and ".".'
                                    })
                                )
                            )
                        ),
                        this.props.enablePostIconOverride && _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'iconURL'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.icon_url',
                                    defaultMessage: 'Profile Picture'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'iconURL',
                                    type: 'text',
                                    maxLength: '1024',
                                    className: 'form-control',
                                    value: this.state.iconURL,
                                    onChange: this.updateIconURL
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_incoming_webhook.icon_url.help',
                                        defaultMessage: 'Choose the profile picture this integration will use when posting. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'backstage-form__footer' },
                            _react2.default.createElement(_form_error2.default, {
                                type: 'backstage',
                                errors: [this.props.serverError, this.state.clientError]
                            }),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-sm',
                                    to: '/' + this.props.team.name + '/integrations/incoming_webhooks'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_incoming_webhook.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                _spinner_button2.default,
                                {
                                    className: 'btn btn-primary',
                                    type: 'submit',
                                    spinning: this.state.saving,
                                    onClick: this.handleSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: footerToRender.id,
                                    defaultMessage: footerToRender.defaultMessage
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return AbstractIncomingWebhook;
}(_react2.default.Component);

AbstractIncomingWebhook.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The header text to render, has id and defaultMessage
    */
    header: _propTypes2.default.object.isRequired,

    /**
    * The footer text to render, has id and defaultMessage
    */
    footer: _propTypes2.default.object.isRequired,

    /**
    * The server error text after a failed action
    */
    serverError: _propTypes2.default.string.isRequired,

    /**
    * The hook used to set the initial state
    */
    initialHook: _propTypes2.default.object,

    /**
    * Whether to allow configuration of the default post username.
    */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,

    /**
    * Whether to allow configuration of the default post icon.
    */
    enablePostIconOverride: _propTypes2.default.bool.isRequired,

    /**
    * The async function to run when the action button is pressed
    */
    action: _propTypes2.default.func.isRequired
};
exports.default = AbstractIncomingWebhook;

/***/ }),

/***/ 1304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _channel_utils = __webpack_require__(830);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ChannelSelect = function (_React$Component) {
    (0, _inherits3.default)(ChannelSelect, _React$Component);
    (0, _createClass3.default)(ChannelSelect, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                onChange: _propTypes2.default.func,
                value: _propTypes2.default.string,
                selectOpen: _propTypes2.default.bool.isRequired,
                selectPrivate: _propTypes2.default.bool.isRequired,
                selectDm: _propTypes2.default.bool.isRequired
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                selectOpen: false,
                selectPrivate: false,
                selectDm: false
            };
        }
    }]);

    function ChannelSelect(props) {
        (0, _classCallCheck3.default)(this, ChannelSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChannelSelect.__proto__ || (0, _getPrototypeOf2.default)(ChannelSelect)).call(this, props));

        _this.handleChannelChange = _this.handleChannelChange.bind(_this);
        _this.filterChannels = _this.filterChannels.bind(_this);

        _this.state = {
            channels: _channel_store2.default.getAll().filter(_this.filterChannels).sort(_channel_utils.sortChannelsByDisplayName)
        };
        return _this;
    }

    (0, _createClass3.default)(ChannelSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _channel_store2.default.addChangeListener(this.handleChannelChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _channel_store2.default.removeChangeListener(this.handleChannelChange);
        }
    }, {
        key: 'handleChannelChange',
        value: function handleChannelChange() {
            this.setState({
                channels: _channel_store2.default.getAll().filter(this.filterChannels).sort(_channel_utils.sortChannelsByDisplayName)
            });
        }
    }, {
        key: 'filterChannels',
        value: function filterChannels(channel) {
            if (channel.display_name) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var options = [_react2.default.createElement(
                'option',
                {
                    key: '',
                    value: ''
                },
                Utils.localizeMessage('channel_select.placeholder', '--- Select a channel ---')
            )];

            this.state.channels.forEach(function (channel) {
                if (channel.type === _constants2.default.OPEN_CHANNEL && _this2.props.selectOpen) {
                    options.push(_react2.default.createElement(
                        'option',
                        {
                            key: channel.id,
                            value: channel.id
                        },
                        channel.display_name
                    ));
                } else if (channel.type === _constants2.default.PRIVATE_CHANNEL && _this2.props.selectPrivate) {
                    options.push(_react2.default.createElement(
                        'option',
                        {
                            key: channel.id,
                            value: channel.id
                        },
                        channel.display_name
                    ));
                } else if (channel.type === _constants2.default.DM_CHANNEL && _this2.props.selectDm) {
                    options.push(_react2.default.createElement(
                        'option',
                        {
                            key: channel.id,
                            value: channel.id
                        },
                        channel.display_name
                    ));
                }
            });

            return _react2.default.createElement(
                'select',
                {
                    className: 'form-control',
                    value: this.props.value,
                    onChange: this.props.onChange
                },
                options
            );
        }
    }]);
    return ChannelSelect;
}(_react2.default.Component);

exports.default = ChannelSelect;

/***/ }),

/***/ 1305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _utils = __webpack_require__(762);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

var _channel_select = __webpack_require__(1304);

var _channel_select2 = _interopRequireDefault(_channel_select);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _spinner_button = __webpack_require__(926);

var _spinner_button2 = _interopRequireDefault(_spinner_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AbstractOutgoingWebhook = function (_React$Component) {
    (0, _inherits3.default)(AbstractOutgoingWebhook, _React$Component);

    function AbstractOutgoingWebhook(props) {
        (0, _classCallCheck3.default)(this, AbstractOutgoingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractOutgoingWebhook.__proto__ || (0, _getPrototypeOf2.default)(AbstractOutgoingWebhook)).call(this, props));

        _this.getStateFromHook = function (hook) {
            var triggerWords = '';
            if (hook.trigger_words) {
                var i = 0;
                for (i = 0; i < hook.trigger_words.length; i++) {
                    triggerWords += hook.trigger_words[i] + '\n';
                }
            }

            var callbackUrls = '';
            if (hook.callback_urls) {
                var _i = 0;
                for (_i = 0; _i < hook.callback_urls.length; _i++) {
                    callbackUrls += hook.callback_urls[_i] + '\n';
                }
            }

            return {
                displayName: hook.display_name || '',
                description: hook.description || '',
                contentType: hook.content_type || 'application/x-www-form-urlencoded',
                channelId: hook.channel_id || '',
                triggerWords: triggerWords,
                triggerWhen: hook.trigger_when || 0,
                callbackUrls: callbackUrls,
                saving: false,
                clientError: null
            };
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            if (_this.state.saving) {
                return;
            }

            _this.setState({
                saving: true,
                clientError: ''
            });

            var triggerWords = [];
            if (_this.state.triggerWords) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_this.state.triggerWords.split('\n')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var triggerWord = _step.value;

                        triggerWord = triggerWord.trim();

                        if (triggerWord.length > 0) {
                            triggerWords.push(triggerWord);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (!_this.state.channelId && triggerWords.length === 0) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_outgoing_webhook.triggerWordsOrChannelRequired',
                        defaultMessage: 'A valid channel or a list of trigger words is required'
                    })
                });

                return;
            }

            var callbackUrls = [];
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(_this.state.callbackUrls.split('\n')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var callbackUrl = _step2.value;

                    callbackUrl = callbackUrl.trim();

                    if (callbackUrl.length > 0) {
                        callbackUrls.push(callbackUrl);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (callbackUrls.length === 0) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_outgoing_webhook.callbackUrlsRequired',
                        defaultMessage: 'One or more callback URLs are required'
                    })
                });

                return;
            }

            var hook = {
                team_id: _team_store2.default.getCurrentId(),
                channel_id: _this.state.channelId,
                trigger_words: triggerWords,
                trigger_when: parseInt(_this.state.triggerWhen, 10),
                callback_urls: callbackUrls,
                display_name: _this.state.displayName,
                content_type: _this.state.contentType,
                description: _this.state.description
            };

            _this.props.action(hook).then(function () {
                return _this.setState({ saving: false });
            });
        };

        _this.updateDisplayName = function (e) {
            _this.setState({
                displayName: e.target.value
            });
        };

        _this.updateDescription = function (e) {
            _this.setState({
                description: e.target.value
            });
        };

        _this.updateContentType = function (e) {
            _this.setState({
                contentType: e.target.value
            });
        };

        _this.updateChannelId = function (e) {
            _this.setState({
                channelId: e.target.value
            });
        };

        _this.updateTriggerWords = function (e) {
            _this.setState({
                triggerWords: e.target.value
            });
        };

        _this.updateTriggerWhen = function (e) {
            _this.setState({
                triggerWhen: e.target.value
            });
        };

        _this.updateCallbackUrls = function (e) {
            _this.setState({
                callbackUrls: e.target.value
            });
        };

        _this.state = _this.getStateFromHook(_this.props.initialHook || {});
        return _this;
    }

    (0, _createClass3.default)(AbstractOutgoingWebhook, [{
        key: 'render',
        value: function render() {
            var contentTypeOption1 = 'application/x-www-form-urlencoded';
            var contentTypeOption2 = 'application/json';

            var headerToRender = this.props.header;
            var footerToRender = this.props.footer;
            var renderExtra = this.props.renderExtra;

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/outgoing_webhooks' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_outgoing_webhooks.header',
                            defaultMessage: 'Outgoing Webhooks'
                        })
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: headerToRender.id,
                        defaultMessage: headerToRender.defaultMessage
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form' },
                    _react2.default.createElement(
                        'form',
                        {
                            className: 'form-horizontal',
                            onSubmit: this.handleSubmit
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'displayName'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.displayName',
                                    defaultMessage: 'Title'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'displayName',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.displayName,
                                    onChange: this.updateDisplayName
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.displayName.help',
                                        defaultMessage: 'Choose a title to be displayed on the webhook settings page. Maximum 64 characters.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'description'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.description',
                                    defaultMessage: 'Description'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'description',
                                    type: 'text',
                                    maxLength: '128',
                                    className: 'form-control',
                                    value: this.state.description,
                                    onChange: this.updateDescription
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.description.help',
                                        defaultMessage: 'Description for your incoming webhook.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'contentType'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.content_Type',
                                    defaultMessage: 'Content Type'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(
                                    'select',
                                    {
                                        className: 'form-control',
                                        value: this.state.contentType,
                                        onChange: this.updateContentType
                                    },
                                    _react2.default.createElement(
                                        'option',
                                        {
                                            value: contentTypeOption1
                                        },
                                        contentTypeOption1
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        {
                                            value: contentTypeOption2
                                        },
                                        contentTypeOption2
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.contentType.help1',
                                        defaultMessage: 'Choose the content type by which the response will be sent.'
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.contentType.help2',
                                        defaultMessage: 'If application/x-www-form-urlencoded is chosen, the server assumes you will be encoding the parameters in a URL format.'
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.contentType.help3',
                                        defaultMessage: 'If application/json is chosen, the server assumes you will posting JSON data.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'channelId'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.channel',
                                    defaultMessage: 'Channel'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(_channel_select2.default, {
                                    id: 'channelId',
                                    value: this.state.channelId,
                                    onChange: this.updateChannelId,
                                    selectOpen: true
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.channel.help',
                                        defaultMessage: 'Public channel to receive webhook payloads. Optional if at least one Trigger Word is specified.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'triggerWords'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.triggerWords',
                                    defaultMessage: 'Trigger Words (One Per Line)'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('textarea', {
                                    id: 'triggerWords',
                                    rows: '3',
                                    maxLength: '1000',
                                    className: 'form-control',
                                    value: this.state.triggerWords,
                                    onChange: this.updateTriggerWords
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.triggerWords.help',
                                        defaultMessage: 'Messages that start with one of the specified words will trigger the outgoing webhook. Optional if Channel is selected.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'triggerWords'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.triggerWordsTriggerWhen',
                                    defaultMessage: 'Trigger When'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(
                                    'select',
                                    {
                                        className: 'form-control',
                                        value: this.state.triggerWhen,
                                        onChange: this.updateTriggerWhen
                                    },
                                    _react2.default.createElement(
                                        'option',
                                        {
                                            value: '0'
                                        },
                                        (0, _utils.localizeMessage)('add_outgoing_webhook.triggerWordsTriggerWhenFullWord', 'First word matches a trigger word exactly')
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        {
                                            value: '1'
                                        },
                                        (0, _utils.localizeMessage)('add_outgoing_webhook.triggerWordsTriggerWhenStartsWith', 'First word starts with a trigger word')
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.triggerWordsTriggerWhen.help',
                                        defaultMessage: 'Choose when to trigger the outgoing webhook; if the first word of a message matches a Trigger Word exactly, or if it starts with a Trigger Word.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'callbackUrls'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.callbackUrls',
                                    defaultMessage: 'Callback URLs (One Per Line)'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('textarea', {
                                    id: 'callbackUrls',
                                    rows: '3',
                                    maxLength: '1000',
                                    className: 'form-control',
                                    value: this.state.callbackUrls,
                                    onChange: this.updateCallbackUrls
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_outgoing_webhook.callbackUrls.help',
                                        defaultMessage: 'The URL that messages will be sent to. If the URL is private, add it as a {link}.',
                                        values: {
                                            link: _react2.default.createElement(
                                                'a',
                                                {
                                                    href: 'https://about.mattermost.com/default-allow-internal-connections-settings-documentation/',
                                                    target: '_blank',
                                                    rel: 'noopener noreferrer'
                                                },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'add_outgoing_webhook.callbackUrls.helpLinkText',
                                                    defaultMessage: 'trusted internal connection'
                                                })
                                            )
                                        }
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'backstage-form__footer' },
                            _react2.default.createElement(_form_error2.default, {
                                type: 'backstage',
                                errors: [this.props.serverError, this.state.clientError]
                            }),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-sm',
                                    to: '/' + this.props.team.name + '/integrations/outgoing_webhooks'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_outgoing_webhook.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                _spinner_button2.default,
                                {
                                    className: 'btn btn-primary',
                                    type: 'submit',
                                    spinning: this.state.saving,
                                    onClick: this.handleSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: footerToRender.id,
                                    defaultMessage: footerToRender.defaultMessage
                                })
                            ),
                            renderExtra
                        )
                    )
                )
            );
        }
    }]);
    return AbstractOutgoingWebhook;
}(_react2.default.Component);

AbstractOutgoingWebhook.propTypes = {

    /**
     * The current team
     */
    team: _propTypes2.default.object.isRequired,

    /**
     * The header text to render, has id and defaultMessage
     */
    header: _propTypes2.default.object.isRequired,

    /**
     * The footer text to render, has id and defaultMessage
     */
    footer: _propTypes2.default.object.isRequired,

    /**
     * Any extra component/node to render
     */
    renderExtra: _propTypes2.default.node.isRequired,

    /**
     * The server error text after a failed action
     */
    serverError: _propTypes2.default.string.isRequired,

    /**
     * The hook used to set the initial state
     */
    initialHook: _propTypes2.default.object,

    /**
     * The async function to run when the action button is pressed
     */
    action: _propTypes2.default.func.isRequired
};
exports.default = AbstractOutgoingWebhook;

/***/ }),

/***/ 1306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(19);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _spinner_button = __webpack_require__(926);

var _spinner_button2 = _interopRequireDefault(_spinner_button);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AbstractOAuthApp = function (_React$PureComponent) {
    (0, _inherits3.default)(AbstractOAuthApp, _React$PureComponent);

    function AbstractOAuthApp(props) {
        (0, _classCallCheck3.default)(this, AbstractOAuthApp);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractOAuthApp.__proto__ || (0, _getPrototypeOf2.default)(AbstractOAuthApp)).call(this, props));

        _this.getStateFromApp = function (app) {
            return {
                name: app.name || '',
                description: app.description || '',
                homepage: app.homepage || '',
                icon_url: app.icon_url || '',
                callbackUrls: app.callback_urls ? app.callback_urls.join('\n') : '',
                is_trusted: app.is_trusted || false,
                has_icon: Boolean(app.icon_url),
                saving: false,
                clientError: null
            };
        };

        _this.imageLoaded = function () {
            _this.setState({
                has_icon: true,
                icon_url: _this.refs.icon_url.value
            });
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            if (_this.state.saving) {
                return;
            }

            _this.setState({
                saving: true,
                clientError: ''
            });

            if (!_this.state.name) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_oauth_app.nameRequired',
                        defaultMessage: 'Name for the OAuth 2.0 application is required.'
                    })
                });

                return;
            }

            if (!_this.state.description) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_oauth_app.descriptionRequired',
                        defaultMessage: 'Description for the OAuth 2.0 application is required.'
                    })
                });

                return;
            }

            if (!_this.state.homepage) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_oauth_app.homepageRequired',
                        defaultMessage: 'Homepage for the OAuth 2.0 application is required.'
                    })
                });

                return;
            }

            var callbackUrls = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(_this.state.callbackUrls.split('\n')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var callbackUrl = _step.value;

                    callbackUrl = callbackUrl.trim();

                    if (callbackUrl.length > 0) {
                        callbackUrls.push(callbackUrl);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (callbackUrls.length === 0) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_oauth_app.callbackUrlsRequired',
                        defaultMessage: 'One or more callback URLs are required.'
                    })
                });

                return;
            }

            var app = {
                name: _this.state.name,
                callback_urls: callbackUrls,
                homepage: _this.state.homepage,
                description: _this.state.description,
                is_trusted: _this.state.is_trusted,
                icon_url: _this.state.icon_url
            };

            _this.props.action(app).then(function () {
                return _this.setState({ saving: false });
            });
        };

        _this.updateName = function (e) {
            _this.setState({
                name: e.target.value
            });
        };

        _this.updateTrusted = function (e) {
            _this.setState({
                is_trusted: e.target.value === 'true'
            });
        };

        _this.updateDescription = function (e) {
            _this.setState({
                description: e.target.value
            });
        };

        _this.updateHomepage = function (e) {
            _this.setState({
                homepage: e.target.value
            });
        };

        _this.updateIconUrl = function (e) {
            _this.setState({
                has_icon: false,
                icon_url: e.target.value
            });
            _this.image.src = e.target.value;
        };

        _this.updateCallbackUrls = function (e) {
            _this.setState({
                callbackUrls: e.target.value
            });
        };

        _this.image = new Image();
        _this.image.onload = _this.imageLoaded;
        _this.state = _this.getStateFromApp(_this.props.initialApp || {});
        return _this;
    }

    (0, _createClass3.default)(AbstractOAuthApp, [{
        key: 'render',
        value: function render() {
            var headerToRender = this.props.header;
            var footerToRender = this.props.footer;
            var renderExtra = this.props.renderExtra;

            var icon = void 0;
            if (this.state.has_icon) {
                icon = _react2.default.createElement(
                    'div',
                    { className: 'integration__icon' },
                    _react2.default.createElement('img', { src: this.state.icon_url })
                );
            }

            var trusted = _react2.default.createElement(
                _system_permission_gate2.default,
                { permissions: [_constants.Permissions.MANAGE_SYSTEM] },
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'is_trusted'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_oauth_apps.trusted',
                            defaultMessage: 'Is Trusted'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-sm-8' },
                        _react2.default.createElement(
                            'label',
                            { className: 'radio-inline' },
                            _react2.default.createElement('input', {
                                type: 'radio',
                                value: 'true',
                                name: 'is_trusted',
                                checked: this.state.is_trusted,
                                onChange: this.updateTrusted
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_oauth_apps.trusted.yes',
                                defaultMessage: 'Yes'
                            })
                        ),
                        _react2.default.createElement(
                            'label',
                            { className: 'radio-inline' },
                            _react2.default.createElement('input', {
                                type: 'radio',
                                value: 'false',
                                name: 'is_trusted',
                                checked: !this.state.is_trusted,
                                onChange: this.updateTrusted
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_oauth_apps.trusted.no',
                                defaultMessage: 'No'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form__help' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'add_oauth_app.trusted.help',
                                defaultMessage: 'When true, the OAuth 2.0 application is considered trusted by the Mattermost server and doesn\'t require the user to accept authorization. When false, an additional window will appear, asking the user to accept or deny the authorization.'
                            })
                        )
                    )
                )
            );

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/oauth2-apps' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_oauth_apps.header',
                            defaultMessage: 'Installed OAuth2 Apps'
                        })
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: headerToRender.id,
                        defaultMessage: headerToRender.defaultMessage
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form' },
                    icon,
                    _react2.default.createElement(
                        'form',
                        { className: 'form-horizontal' },
                        trusted,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'name'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.name',
                                    defaultMessage: 'Display Name'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'name',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.name,
                                    onChange: this.updateName
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_oauth_app.name.help',
                                        defaultMessage: 'Display name for your OAuth 2.0 application made of up to 64 characters.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'description'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.description',
                                    defaultMessage: 'Description'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'description',
                                    type: 'text',
                                    maxLength: '512',
                                    className: 'form-control',
                                    value: this.state.description,
                                    onChange: this.updateDescription
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_oauth_app.description.help',
                                        defaultMessage: 'Description for your OAuth 2.0 application.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'homepage'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.homepage',
                                    defaultMessage: 'Homepage'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'homepage',
                                    type: 'url',
                                    maxLength: '256',
                                    className: 'form-control',
                                    value: this.state.homepage,
                                    onChange: this.updateHomepage
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_oauth_app.homepage.help',
                                        defaultMessage: 'The URL for the homepage of the OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL depending on your server configuration.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'icon_url'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.iconUrl',
                                    defaultMessage: 'Icon URL'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'icon_url',
                                    ref: 'icon_url',
                                    type: 'url',
                                    maxLength: '512',
                                    className: 'form-control',
                                    value: this.state.icon_url,
                                    onChange: this.updateIconUrl
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_oauth_app.icon.help',
                                        defaultMessage: 'The URL for the homepage of the OAuth 2.0 application. Make sure you use HTTP or HTTPS in your URL depending on your server configuration.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'callbackUrls'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.callbackUrls',
                                    defaultMessage: 'Callback URLs (One Per Line)'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('textarea', {
                                    id: 'callbackUrls',
                                    rows: '3',
                                    maxLength: '1024',
                                    className: 'form-control',
                                    value: this.state.callbackUrls,
                                    onChange: this.updateCallbackUrls
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_oauth_app.callbackUrls.help',
                                        defaultMessage: 'The redirect URIs to which the service will redirect users after accepting or denying authorization of your application, and which will handle authorization codes or access tokens. Must be a valid URL and start with http:// or https://.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'backstage-form__footer' },
                            _react2.default.createElement(_form_error2.default, {
                                type: 'backstage',
                                errors: [this.props.serverError, this.state.clientError]
                            }),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-sm',
                                    to: '/' + this.props.team.name + '/integrations/oauth2-apps'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                _spinner_button2.default,
                                {
                                    className: 'btn btn-primary',
                                    type: 'submit',
                                    spinning: this.state.saving,
                                    onClick: this.handleSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: footerToRender.id,
                                    defaultMessage: footerToRender.defaultMessage
                                })
                            ),
                            renderExtra
                        )
                    )
                )
            );
        }
    }]);
    return AbstractOAuthApp;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AbstractOAuthApp.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The header text to render, has id and defaultMessage
    */
    header: _propTypes2.default.object.isRequired,

    /**
    * The footer text to render, has id and defaultMessage
    */
    footer: _propTypes2.default.object.isRequired,

    /**
     * Any extra component/node to render
     */
    renderExtra: _propTypes2.default.node.isRequired,

    /**
    * The server error text after a failed action
    */
    serverError: _propTypes2.default.string.isRequired,

    /**
    * The OAuthApp used to set the initial state
    */
    initialApp: _propTypes2.default.object,

    /**
    * The async function to run when the action button is pressed
    */
    action: _propTypes2.default.func.isRequired
};
exports.default = AbstractOAuthApp;

/***/ }),

/***/ 1307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _spinner_button = __webpack_require__(926);

var _spinner_button2 = _interopRequireDefault(_spinner_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_POST = 'P'; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var REQUEST_GET = 'G';

var AbstractCommand = function (_React$PureComponent) {
    (0, _inherits3.default)(AbstractCommand, _React$PureComponent);

    function AbstractCommand(props) {
        (0, _classCallCheck3.default)(this, AbstractCommand);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractCommand.__proto__ || (0, _getPrototypeOf2.default)(AbstractCommand)).call(this, props));

        _this.getStateFromCommand = function (command) {
            return {
                displayName: command.display_name || '',
                description: command.description || '',
                trigger: command.trigger || '',
                url: command.url || '',
                method: command.method || REQUEST_POST,
                username: command.username || '',
                iconUrl: command.icon_url || '',
                autocomplete: command.auto_complete || false,
                autocompleteHint: command.auto_complete_hint || '',
                autocompleteDescription: command.auto_complete_desc || '',
                saving: false,
                clientError: null
            };
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            if (_this.state.saving) {
                return;
            }

            _this.setState({
                saving: true,
                clientError: ''
            });

            var triggerWord = _this.state.trigger.trim().toLowerCase();
            if (triggerWord.indexOf('/') === 0) {
                triggerWord = triggerWord.substr(1);
            }

            var command = {
                display_name: _this.state.displayName,
                description: _this.state.description,
                trigger: triggerWord,
                url: _this.state.url.trim(),
                method: _this.state.method,
                username: _this.state.username,
                icon_url: _this.state.iconUrl,
                auto_complete: _this.state.autocomplete,
                team_id: _this.props.team.id
            };

            if (command.auto_complete) {
                command.auto_complete_desc = _this.state.autocompleteDescription;
                command.auto_complete_hint = _this.state.autocompleteHint;
            }

            if (!command.trigger) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_command.triggerRequired',
                        defaultMessage: 'A trigger word is required'
                    })
                });

                return;
            }

            if (command.trigger.indexOf('/') === 0) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_command.triggerInvalidSlash',
                        defaultMessage: 'A trigger word cannot begin with a /'
                    })
                });

                return;
            }

            if (command.trigger.indexOf(' ') !== -1) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_command.triggerInvalidSpace',
                        defaultMessage: 'A trigger word must not contain spaces'
                    })
                });
                return;
            }

            if (command.trigger.length < _constants2.default.MIN_TRIGGER_LENGTH || command.trigger.length > _constants2.default.MAX_TRIGGER_LENGTH) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_command.triggerInvalidLength',
                        defaultMessage: 'A trigger word must contain between {min} and {max} characters',
                        values: {
                            min: _constants2.default.MIN_TRIGGER_LENGTH,
                            max: _constants2.default.MAX_TRIGGER_LENGTH
                        }
                    })
                });

                return;
            }

            if (!command.url) {
                _this.setState({
                    saving: false,
                    clientError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_command.urlRequired',
                        defaultMessage: 'A request URL is required'
                    })
                });

                return;
            }

            _this.props.action(command).then(function () {
                return _this.setState({ saving: false });
            });
        };

        _this.updateDisplayName = function (e) {
            _this.setState({
                displayName: e.target.value
            });
        };

        _this.updateDescription = function (e) {
            _this.setState({
                description: e.target.value
            });
        };

        _this.updateTrigger = function (e) {
            _this.setState({
                trigger: e.target.value
            });
        };

        _this.updateUrl = function (e) {
            _this.setState({
                url: e.target.value
            });
        };

        _this.updateMethod = function (e) {
            _this.setState({
                method: e.target.value
            });
        };

        _this.updateUsername = function (e) {
            _this.setState({
                username: e.target.value
            });
        };

        _this.updateIconUrl = function (e) {
            _this.setState({
                iconUrl: e.target.value
            });
        };

        _this.updateAutocomplete = function (e) {
            _this.setState({
                autocomplete: e.target.checked
            });
        };

        _this.updateAutocompleteHint = function (e) {
            _this.setState({
                autocompleteHint: e.target.value
            });
        };

        _this.updateAutocompleteDescription = function (e) {
            _this.setState({
                autocompleteDescription: e.target.value
            });
        };

        _this.state = _this.getStateFromCommand(_this.props.initialCommand || {});
        return _this;
    }

    (0, _createClass3.default)(AbstractCommand, [{
        key: 'render',
        value: function render() {
            var autocompleteHint = null;
            var autocompleteDescription = null;

            if (this.state.autocomplete) {
                autocompleteHint = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'autocompleteHint'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'add_command.autocompleteHint',
                            defaultMessage: 'Autocomplete Hint'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-sm-8' },
                        _react2.default.createElement('input', {
                            id: 'autocompleteHint',
                            type: 'text',
                            maxLength: '1024',
                            className: 'form-control',
                            value: this.state.autocompleteHint,
                            onChange: this.updateAutocompleteHint,
                            placeholder: Utils.localizeMessage('add_command.autocompleteHint.placeholder', 'Example: [Patient Name]')
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'form__help' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'add_command.autocompleteHint.help',
                                defaultMessage: '(Optional) Arguments associated with your slash command, displayed as help in the autocomplete list.'
                            })
                        )
                    )
                );

                autocompleteDescription = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'autocompleteDescription'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'add_command.autocompleteDescription',
                            defaultMessage: 'Autocomplete Description'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-sm-8' },
                        _react2.default.createElement('input', {
                            id: 'description',
                            type: 'text',
                            maxLength: '128',
                            className: 'form-control',
                            value: this.state.autocompleteDescription,
                            onChange: this.updateAutocompleteDescription,
                            placeholder: Utils.localizeMessage('add_command.autocompleteDescription.placeholder', 'Example: "Returns search results for patient records"')
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'form__help' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'add_command.autocompleteDescription.help',
                                defaultMessage: '(Optional) Short description of slash command for the autocomplete list.'
                            })
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content row' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/commands' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_command.header',
                            defaultMessage: 'Slash Commands'
                        })
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: this.props.header.id,
                        defaultMessage: this.props.header.defaultMessage
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form' },
                    _react2.default.createElement(
                        'form',
                        {
                            className: 'form-horizontal',
                            onSubmit: this.handleSubmit
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'displayName'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.displayName',
                                    defaultMessage: 'Title'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'displayName',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.displayName,
                                    onChange: this.updateDisplayName
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.displayName.help',
                                        defaultMessage: 'Choose a title to be displayed on the slash command settings page. Maximum 64 characters.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'description'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.description',
                                    defaultMessage: 'Description'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'description',
                                    type: 'text',
                                    maxLength: '128',
                                    className: 'form-control',
                                    value: this.state.description,
                                    onChange: this.updateDescription
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.description.help',
                                        defaultMessage: 'Description for your incoming webhook.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'trigger'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.trigger',
                                    defaultMessage: 'Command Trigger Word'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'trigger',
                                    type: 'text',
                                    maxLength: _constants2.default.MAX_TRIGGER_LENGTH,
                                    className: 'form-control',
                                    value: this.state.trigger,
                                    onChange: this.updateTrigger,
                                    placeholder: Utils.localizeMessage('add_command.trigger.placeholder', 'Command trigger e.g. "hello" not including the slash')
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.trigger.help',
                                        defaultMessage: 'Trigger word must be unique, and cannot begin with a slash or contain any spaces.'
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.trigger.helpExamples',
                                        defaultMessage: 'Examples: client, employee, patient, weather'
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.trigger.helpReserved',
                                        defaultMessage: 'Reserved: {link}',
                                        values: {
                                            link: _react2.default.createElement(
                                                'a',
                                                {
                                                    href: 'https://docs.mattermost.com/help/messaging/executing-commands.html#built-in-commands',
                                                    target: '_blank',
                                                    rel: 'noopener noreferrer'
                                                },
                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'add_command.trigger.helpReservedLinkText',
                                                    defaultMessage: 'see list of built-in slash commands'
                                                })
                                            )
                                        }
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'url'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.url',
                                    defaultMessage: 'Request URL'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'url',
                                    type: 'text',
                                    maxLength: '1024',
                                    className: 'form-control',
                                    value: this.state.url,
                                    onChange: this.updateUrl,
                                    placeholder: Utils.localizeMessage('add_command.url.placeholder', 'Must start with http:// or https://')
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.url.help',
                                        defaultMessage: 'The callback URL to receive the HTTP POST or GET event request when the slash command is run.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'method'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.method',
                                    defaultMessage: 'Request Method'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(
                                    'select',
                                    {
                                        id: 'method',
                                        className: 'form-control',
                                        value: this.state.method,
                                        onChange: this.updateMethod
                                    },
                                    _react2.default.createElement(
                                        'option',
                                        { value: REQUEST_POST },
                                        Utils.localizeMessage('add_command.method.post', 'POST')
                                    ),
                                    _react2.default.createElement(
                                        'option',
                                        { value: REQUEST_GET },
                                        Utils.localizeMessage('add_command.method.get', 'GET')
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.method.help',
                                        defaultMessage: 'The type of command request issued to the Request URL.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'username'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.username',
                                    defaultMessage: 'Response Username'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'username',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.username,
                                    onChange: this.updateUsername,
                                    placeholder: Utils.localizeMessage('add_command.username.placeholder', 'Username')
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.username.help',
                                        defaultMessage: '(Optional) Choose a username override for responses for this slash command. Usernames can consist of up to 22 characters consisting of lowercase letters, numbers and they symbols "-", "_", and "." .'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'iconUrl'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.iconUrl',
                                    defaultMessage: 'Response Icon'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'iconUrl',
                                    type: 'text',
                                    maxLength: '1024',
                                    className: 'form-control',
                                    value: this.state.iconUrl,
                                    onChange: this.updateIconUrl,
                                    placeholder: Utils.localizeMessage('add_command.iconUrl.placeholder', 'https://www.example.com/myicon.png')
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.iconUrl.help',
                                        defaultMessage: '(Optional) Choose a profile picture override for the post responses to this slash command. Enter the URL of a .png or .jpg file at least 128 pixels by 128 pixels.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'autocomplete'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.autocomplete',
                                    defaultMessage: 'Autocomplete'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8 checkbox' },
                                _react2.default.createElement('input', {
                                    id: 'autocomplete',
                                    type: 'checkbox',
                                    checked: this.state.autocomplete,
                                    onChange: this.updateAutocomplete
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_command.autocomplete.help',
                                        defaultMessage: '(Optional) Show slash command in autocomplete list.'
                                    })
                                )
                            )
                        ),
                        autocompleteHint,
                        autocompleteDescription,
                        _react2.default.createElement(
                            'div',
                            { className: 'backstage-form__footer' },
                            _react2.default.createElement(_form_error2.default, {
                                type: 'backstage',
                                errors: [this.props.serverError, this.state.clientError]
                            }),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-sm',
                                    to: '/' + this.props.team.name + '/integrations/commands'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_command.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                _spinner_button2.default,
                                {
                                    className: 'btn btn-primary',
                                    type: 'submit',
                                    spinning: this.state.saving,
                                    onClick: this.handleSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: this.props.footer.id,
                                    defaultMessage: this.props.footer.defaultMessage
                                })
                            ),
                            this.props.renderExtra
                        )
                    )
                )
            );
        }
    }]);
    return AbstractCommand;
}(_react2.default.PureComponent);

AbstractCommand.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The header text to render, has id and defaultMessage
    */
    header: _propTypes2.default.object.isRequired,

    /**
    * The footer text to render, has id and defaultMessage
    */
    footer: _propTypes2.default.object.isRequired,

    /**
     * Any extra component/node to render
     */
    renderExtra: _propTypes2.default.node.isRequired,

    /**
    * The server error text after a failed action
    */
    serverError: _propTypes2.default.string.isRequired,

    /**
    * The Command used to set the initial state
    */
    initialCommand: _propTypes2.default.object,

    /**
    * The async function to run when the action button is pressed
    */
    action: _propTypes2.default.func.isRequired
};
exports.default = AbstractCommand;

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _integrations = __webpack_require__(908);

var _confirm_integration = __webpack_require__(1942);

var _confirm_integration2 = _interopRequireDefault(_confirm_integration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        commands: (0, _integrations.getCommands)(state)
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_confirm_integration2.default);

/***/ }),

/***/ 1891:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _reactRouterDom = __webpack_require__(269);

var _users = __webpack_require__(777);

var _teams = __webpack_require__(274);

var _general = __webpack_require__(113);

var _backstage_controller = __webpack_require__(1892);

var _backstage_controller2 = _interopRequireDefault(_backstage_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var user = (0, _users.getCurrentUser)(state);
    var team = (0, _teams.getCurrentTeam)(state);

    var config = (0, _general.getConfig)(state);

    var siteName = config.SiteName;
    var enableCustomEmoji = config.EnableCustomEmoji === 'true';
    var enableIncomingWebhooks = config.EnableIncomingWebhooks === 'true';
    var enableOutgoingWebhooks = config.EnableOutgoingWebhooks === 'true';
    var enableCommands = config.EnableCommands === 'true';
    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';

    return {
        user: user,
        team: team,
        siteName: siteName,
        enableCustomEmoji: enableCustomEmoji,
        enableIncomingWebhooks: enableIncomingWebhooks,
        enableOutgoingWebhooks: enableOutgoingWebhooks,
        enableCommands: enableCommands,
        enableOAuthServiceProvider: enableOAuthServiceProvider
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(_backstage_controller2.default));

/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(269);

var _pluggable = __webpack_require__(881);

var _pluggable2 = _interopRequireDefault(_pluggable);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _integrations = __webpack_require__(1895);

var _integrations2 = _interopRequireDefault(_integrations);

var _emoji = __webpack_require__(1904);

var _emoji2 = _interopRequireDefault(_emoji);

var _add_emoji = __webpack_require__(1911);

var _add_emoji2 = _interopRequireDefault(_add_emoji);

var _installed_incoming_webhooks = __webpack_require__(1912);

var _installed_incoming_webhooks2 = _interopRequireDefault(_installed_incoming_webhooks);

var _add_incoming_webhook = __webpack_require__(1915);

var _add_incoming_webhook2 = _interopRequireDefault(_add_incoming_webhook);

var _edit_incoming_webhook = __webpack_require__(1917);

var _edit_incoming_webhook2 = _interopRequireDefault(_edit_incoming_webhook);

var _installed_outgoing_webhooks = __webpack_require__(1919);

var _installed_outgoing_webhooks2 = _interopRequireDefault(_installed_outgoing_webhooks);

var _add_outgoing_webhook = __webpack_require__(1922);

var _add_outgoing_webhook2 = _interopRequireDefault(_add_outgoing_webhook);

var _edit_outgoing_webhook = __webpack_require__(1924);

var _edit_outgoing_webhook2 = _interopRequireDefault(_edit_outgoing_webhook);

var _installed_oauth_apps = __webpack_require__(1926);

var _installed_oauth_apps2 = _interopRequireDefault(_installed_oauth_apps);

var _add_oauth_app = __webpack_require__(1929);

var _add_oauth_app2 = _interopRequireDefault(_add_oauth_app);

var _edit_oauth_app = __webpack_require__(1931);

var _edit_oauth_app2 = _interopRequireDefault(_edit_oauth_app);

var _commands_container = __webpack_require__(1933);

var _commands_container2 = _interopRequireDefault(_commands_container);

var _confirm_integration = __webpack_require__(1308);

var _confirm_integration2 = _interopRequireDefault(_confirm_integration);

var _backstage_sidebar = __webpack_require__(1944);

var _backstage_sidebar2 = _interopRequireDefault(_backstage_sidebar);

var _backstage_navbar = __webpack_require__(1947);

var _backstage_navbar2 = _interopRequireDefault(_backstage_navbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageRoute = function BackstageRoute(_ref) {
    var Component = _ref.component,
        extraProps = _ref.extraProps,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component', 'extraProps']);
    return (//eslint-disable-line react/prop-types
        _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
            render: function render(props) {
                return _react2.default.createElement(Component, (0, _extends3.default)({}, extraProps, props));
            }
        }))
    );
}; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BackstageController = function (_React$Component) {
    (0, _inherits3.default)(BackstageController, _React$Component);

    function BackstageController() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BackstageController);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = BackstageController.__proto__ || (0, _getPrototypeOf2.default)(BackstageController)).call.apply(_ref2, [this].concat(args))), _this), _this.scrollToTop = function () {
            if (_this.listRef) {
                _this.listRef.scrollTop = 0;
            }
        }, _this.setListRef = function (ref) {
            _this.listRef = ref;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BackstageController, [{
        key: 'render',
        value: function render() {
            if (this.props.team == null || this.props.user == null) {
                return _react2.default.createElement('div', null);
            }
            var extraProps = {
                team: this.props.team,
                user: this.props.user,
                scrollToTop: this.scrollToTop
            };
            return _react2.default.createElement(
                'div',
                { className: 'backstage' },
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(_backstage_navbar2.default, {
                    team: this.props.team,
                    siteName: this.props.siteName
                }),
                _react2.default.createElement(_pluggable2.default, { pluggableName: 'Root' }),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'backstage-body',
                        ref: this.setListRef
                    },
                    _react2.default.createElement(_backstage_sidebar2.default, {
                        team: this.props.team,
                        user: this.props.user,
                        enableCustomEmoji: this.props.enableCustomEmoji,
                        enableIncomingWebhooks: this.props.enableIncomingWebhooks,
                        enableOutgoingWebhooks: this.props.enableOutgoingWebhooks,
                        enableCommands: this.props.enableCommands,
                        enableOAuthServiceProvider: this.props.enableOAuthServiceProvider
                    }),
                    _react2.default.createElement(
                        _reactRouterDom.Switch,
                        null,
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            exact: true,
                            path: '/:team/integrations',
                            component: _integrations2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            exact: true,
                            path: this.props.match.url + '/incoming_webhooks',
                            component: _installed_incoming_webhooks2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/incoming_webhooks/add',
                            component: _add_incoming_webhook2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/incoming_webhooks/edit',
                            component: _edit_incoming_webhook2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            exact: true,
                            path: this.props.match.url + '/outgoing_webhooks',
                            component: _installed_outgoing_webhooks2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/outgoing_webhooks/add',
                            component: _add_outgoing_webhook2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/outgoing_webhooks/edit',
                            component: _edit_outgoing_webhook2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/commands',
                            component: _commands_container2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            exact: true,
                            path: this.props.match.url + '/oauth2-apps',
                            component: _installed_oauth_apps2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/oauth2-apps/add',
                            component: _add_oauth_app2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/oauth2-apps/edit',
                            component: _edit_oauth_app2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/confirm',
                            component: _confirm_integration2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            exact: true,
                            path: '/:team/emoji',
                            component: _emoji2.default
                        }),
                        _react2.default.createElement(BackstageRoute, {
                            extraProps: extraProps,
                            path: this.props.match.url + '/add',
                            component: _add_emoji2.default
                        })
                    )
                )
            );
        }
    }]);
    return BackstageController;
}(_react2.default.Component);

BackstageController.propTypes = {

    /**
     * Current user.
     */
    user: _propTypes2.default.object,

    /**
     * Current team.
     */
    team: _propTypes2.default.object,

    /**
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired,

    siteName: _propTypes2.default.string,
    enableCustomEmoji: _propTypes2.default.bool.isRequired,
    enableIncomingWebhooks: _propTypes2.default.bool.isRequired,
    enableOutgoingWebhooks: _propTypes2.default.bool.isRequired,
    enableCommands: _propTypes2.default.bool.isRequired,
    enableOAuthServiceProvider: _propTypes2.default.bool.isRequired
};
exports.default = BackstageController;

/***/ }),

/***/ 1895:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _integrations = __webpack_require__(1896);

var _integrations2 = _interopRequireDefault(_integrations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var siteName = config.SiteName;
    var enableIncomingWebhooks = config.EnableIncomingWebhooks === 'true';
    var enableOutgoingWebhooks = config.EnableOutgoingWebhooks === 'true';
    var enableCommands = config.EnableCommands === 'true';
    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';
    var enableOnlyAdminIntegrations = config.EnableOnlyAdminIntegrations === 'true';

    return {
        siteName: siteName,
        enableIncomingWebhooks: enableIncomingWebhooks,
        enableOutgoingWebhooks: enableOutgoingWebhooks,
        enableCommands: enableCommands,
        enableOAuthServiceProvider: enableOAuthServiceProvider,
        enableOnlyAdminIntegrations: enableOnlyAdminIntegrations
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_integrations2.default);

/***/ }),

/***/ 1896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _incoming_webhook = __webpack_require__(1897);

var _incoming_webhook2 = _interopRequireDefault(_incoming_webhook);

var _oauth_icon = __webpack_require__(1898);

var _oauth_icon2 = _interopRequireDefault(_oauth_icon);

var _outgoing_webhook = __webpack_require__(1899);

var _outgoing_webhook2 = _interopRequireDefault(_outgoing_webhook);

var _slash_command_icon = __webpack_require__(1900);

var _slash_command_icon2 = _interopRequireDefault(_slash_command_icon);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _integration_option = __webpack_require__(1903);

var _integration_option2 = _interopRequireDefault(_integration_option);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Integrations = function (_React$Component) {
    (0, _inherits3.default)(Integrations, _React$Component);

    function Integrations() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Integrations);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Integrations.__proto__ || (0, _getPrototypeOf2.default)(Integrations)).call.apply(_ref, [this].concat(args))), _this), _this.updateTitle = function () {
            var currentSiteName = _this.props.siteName || '';
            document.title = Utils.localizeMessage('admin.sidebar.integrations', 'Integrations') + ' - ' + _this.props.team.display_name + ' ' + currentSiteName;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Integrations, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateTitle();
        }
    }, {
        key: 'render',
        value: function render() {
            var options = [];

            if (this.props.enableIncomingWebhooks) {
                options.push(_react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.team.id,
                        permissions: [_constants.Permissions.MANAGE_WEBHOOKS],
                        key: 'incomingWebhookPermission'
                    },
                    _react2.default.createElement(_integration_option2.default, {
                        key: 'incomingWebhook',
                        image: _incoming_webhook2.default,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.incomingWebhook.title',
                            defaultMessage: 'Incoming Webhook'
                        }),
                        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.incomingWebhook.description',
                            defaultMessage: 'Incoming webhooks allow external integrations to send messages'
                        }),
                        link: '/' + this.props.team.name + '/integrations/incoming_webhooks'
                    })
                ));
            }

            if (this.props.enableOutgoingWebhooks) {
                options.push(_react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.team.id,
                        permissions: [_constants.Permissions.MANAGE_WEBHOOKS],
                        key: 'outgoingWebhookPermission'
                    },
                    _react2.default.createElement(_integration_option2.default, {
                        key: 'outgoingWebhook',
                        image: _outgoing_webhook2.default,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.outgoingWebhook.title',
                            defaultMessage: 'Outgoing Webhook'
                        }),
                        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.outgoingWebhook.description',
                            defaultMessage: 'Outgoing webhooks allow external integrations to receive and respond to messages'
                        }),
                        link: '/' + this.props.team.name + '/integrations/outgoing_webhooks'
                    })
                ));
            }

            if (this.props.enableCommands) {
                options.push(_react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        teamId: this.props.team.id,
                        permissions: [_constants.Permissions.MANAGE_SLASH_COMMANDS],
                        key: 'commandPermission'
                    },
                    _react2.default.createElement(_integration_option2.default, {
                        key: 'command',
                        image: _slash_command_icon2.default,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.command.title',
                            defaultMessage: 'Slash Command'
                        }),
                        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.command.description',
                            defaultMessage: 'Slash commands send events to an external integration'
                        }),
                        link: '/' + this.props.team.name + '/integrations/commands'
                    })
                ));
            }

            if (this.props.enableOAuthServiceProvider) {
                options.push(_react2.default.createElement(
                    _system_permission_gate2.default,
                    {
                        permissions: [_constants.Permissions.MANAGE_OAUTH],
                        key: 'oauth2AppsPermission'
                    },
                    _react2.default.createElement(_integration_option2.default, {
                        key: 'oauth2Apps',
                        image: _oauth_icon2.default,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.oauthApps.title',
                            defaultMessage: 'OAuth 2.0 Applications'
                        }),
                        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.oauthApps.description',
                            defaultMessage: 'Auth 2.0 allows external applications to make authorized requests to the Mattermost API.'
                        }),
                        link: '/' + this.props.team.name + '/integrations/oauth2-apps'
                    })
                ));
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content row' },
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-header' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.header',
                            defaultMessage: 'Integrations'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-list__help' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'integrations.help',
                        defaultMessage: 'Visit the {appDirectory} to find self-hosted, third-party apps and integrations for Mattermost.',
                        values: {
                            appDirectory: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://about.mattermost.com/default-app-directory/'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'integrations.help.appDirectory',
                                    defaultMessage: 'App Directory'
                                })
                            )
                        }
                    })
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    options
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                team: _propTypes2.default.object,
                user: _propTypes2.default.object,
                siteName: _propTypes2.default.string,
                enableIncomingWebhooks: _propTypes2.default.bool,
                enableOutgoingWebhooks: _propTypes2.default.bool,
                enableCommands: _propTypes2.default.bool,
                enableOAuthServiceProvider: _propTypes2.default.bool,
                enableOnlyAdminIntegrations: _propTypes2.default.bool
            };
        }
    }]);
    return Integrations;
}(_react2.default.Component);

exports.default = Integrations;

/***/ }),

/***/ 1897:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/fd69f7891f867c2aa14011da92b728ac.jpg";

/***/ }),

/***/ 1898:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/ce81936d829c1ac530749ba2fe913de0.png";

/***/ }),

/***/ 1899:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/2aa264fb1956b8be41f2047d428a1a1e.jpg";

/***/ }),

/***/ 1900:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/d184fcdb23c1e24bfd7132950ceb4f68.jpg";

/***/ }),

/***/ 1903:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegrationOption = function (_React$Component) {
    (0, _inherits3.default)(IntegrationOption, _React$Component);

    function IntegrationOption() {
        (0, _classCallCheck3.default)(this, IntegrationOption);
        return (0, _possibleConstructorReturn3.default)(this, (IntegrationOption.__proto__ || (0, _getPrototypeOf2.default)(IntegrationOption)).apply(this, arguments));
    }

    (0, _createClass3.default)(IntegrationOption, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                image = _props.image,
                title = _props.title,
                description = _props.description,
                link = _props.link;


            return _react2.default.createElement(
                _reactRouterDom.Link,
                {
                    to: link,
                    className: 'integration-option'
                },
                _react2.default.createElement('img', {
                    className: 'integration-option__image',
                    src: image
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'integration-option__title' },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'integration-option__description' },
                    description
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                image: _propTypes2.default.string.isRequired,
                title: _propTypes2.default.node.isRequired,
                description: _propTypes2.default.node.isRequired,
                link: _propTypes2.default.string.isRequired
            };
        }
    }]);
    return IntegrationOption;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = IntegrationOption;

/***/ }),

/***/ 1904:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _teams = __webpack_require__(274);

var _emoji_page = __webpack_require__(1905);

var _emoji_page2 = _interopRequireDefault(_emoji_page);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var team = (0, _teams.getCurrentTeam)(state) || {};

    return {
        teamName: team.name,
        teamDisplayName: team.display_name,
        siteName: state.entities.general.config.SiteName
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_emoji_page2.default);

/***/ }),

/***/ 1905:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _emoji_list = __webpack_require__(1906);

var _emoji_list2 = _interopRequireDefault(_emoji_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmojiPage = function (_React$Component) {
    (0, _inherits3.default)(EmojiPage, _React$Component);

    function EmojiPage() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, EmojiPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmojiPage.__proto__ || (0, _getPrototypeOf2.default)(EmojiPage)).call.apply(_ref, [this].concat(args))), _this), _this.updateTitle = function () {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

            document.title = Utils.localizeMessage('custom_emoji.header', 'Custom Emoji') + ' - ' + props.teamDisplayName + ' ' + props.siteName;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(EmojiPage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateTitle();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.siteName !== nextProps.siteName) {
                this.updateTitle(nextProps);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'backstage-content emoji-list' },
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-header' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'emoji_list.header',
                            defaultMessage: 'Custom Emoji'
                        })
                    ),
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            className: 'add-link',
                            to: '/' + this.props.teamName + '/emoji/add'
                        },
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-primary'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'emoji_list.add',
                                defaultMessage: 'Add Custom Emoji'
                            })
                        )
                    ),
                    _react2.default.createElement(_emoji_list2.default, { scrollToTop: this.props.scrollToTop })
                )
            );
        }
    }]);
    return EmojiPage;
}(_react2.default.Component);

EmojiPage.propTypes = {

    /**
     * Non-UI team name for the current team.
     */
    teamName: _propTypes2.default.string.isRequired,

    /**
     * UI team name for the current team.
     */
    teamDisplayName: _propTypes2.default.string.isRequired,

    /**
     * Title of the app or site.
     */
    siteName: _propTypes2.default.string,

    /**
     * Function to scroll list to top.
     */
    scrollToTop: _propTypes2.default.func.isRequired
};
EmojiPage.defaultProps = {
    teamName: '',
    teamDisplayName: '',
    siteName: ''
};
exports.default = EmojiPage;

/***/ }),

/***/ 1906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _emojis = __webpack_require__(877);

var _emojis2 = __webpack_require__(853);

var _emoji_list = __webpack_require__(1907);

var _emoji_list2 = _interopRequireDefault(_emoji_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        emojiIds: (0, _emojis.getCustomEmojiIdsSortedByName)(state) || []
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getCustomEmojis: _emojis2.getCustomEmojis,
            searchCustomEmojis: _emojis2.searchCustomEmojis
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_emoji_list2.default);

/***/ }),

/***/ 1907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _utils = __webpack_require__(762);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _save_button = __webpack_require__(925);

var _save_button2 = _interopRequireDefault(_save_button);

var _emoji_list_item = __webpack_require__(1908);

var _emoji_list_item2 = _interopRequireDefault(_emoji_list_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EMOJI_PER_PAGE = 50;
var EMOJI_SEARCH_DELAY_MILLISECONDS = 200;

var EmojiList = function (_React$Component) {
    (0, _inherits3.default)(EmojiList, _React$Component);

    function EmojiList(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EmojiList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmojiList.__proto__ || (0, _getPrototypeOf2.default)(EmojiList)).call(this, props));

        _this.nextPage = function (e) {
            if (e) {
                e.preventDefault();
            }

            var next = _this.state.page + 1;
            _this.setState({ nextLoading: true });
            _this.props.actions.getCustomEmojis(next, EMOJI_PER_PAGE, _constants.Emoji.SORT_BY_NAME, true).then(function (_ref) {
                var data = _ref.data;

                _this.setState({ page: next, nextLoading: false });
                if (data && data.length < EMOJI_PER_PAGE) {
                    _this.setState({ missingPages: false });
                }

                _this.props.scrollToTop();
            });
        };

        _this.previousPage = function (e) {
            if (e) {
                e.preventDefault();
            }

            _this.setState({ page: _this.state.page - 1, nextLoading: false });
            _this.props.scrollToTop();
        };

        _this.onSearchChange = function (e) {
            if (!e || !e.target) {
                return;
            }

            var term = e.target.value || '';

            clearTimeout(_this.searchTimeout);

            _this.searchTimeout = setTimeout((0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _ref3, data;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(term.trim() === '')) {
                                    _context.next = 3;
                                    break;
                                }

                                _this.setState({ searchEmojis: null, page: 0 });
                                return _context.abrupt('return');

                            case 3:

                                _this.setState({ loading: true });

                                _context.next = 6;
                                return _this.props.actions.searchCustomEmojis(term);

                            case 6:
                                _ref3 = _context.sent;
                                data = _ref3.data;


                                if (data) {
                                    _this.setState({ searchEmojis: data.map(function (em) {
                                            return em.id;
                                        }), loading: false });
                                } else {
                                    _this.setState({ searchEmojis: [], loading: false });
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            })), EMOJI_SEARCH_DELAY_MILLISECONDS);
        };

        _this.deleteFromSearch = function (emojiId) {
            if (!_this.state.searchEmojis) {
                return;
            }

            var index = _this.state.searchEmojis.indexOf(emojiId);

            if (index < 0) {
                return;
            }

            var newSearchEmojis = [].concat((0, _toConsumableArray3.default)(_this.state.searchEmojis));
            newSearchEmojis.splice(index, 1);
            _this.setState({ searchEmojis: newSearchEmojis });
        };

        _this.searchTimeout = null;

        _this.state = {
            loading: true,
            page: 0,
            nextLoading: false,
            searchEmojis: null,
            missingPages: true
        };
        return _this;
    }

    (0, _createClass3.default)(EmojiList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            this.props.actions.getCustomEmojis(0, EMOJI_PER_PAGE + 1, _constants.Emoji.SORT_BY_NAME, true).then(function (_ref4) {
                var data = _ref4.data;

                _this3.setState({ loading: false });
                if (data && data.length < EMOJI_PER_PAGE) {
                    _this3.setState({ missingPages: false });
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var searchEmojis = this.state.searchEmojis;
            var emojis = [];
            var nextButton = void 0;
            var previousButton = void 0;

            if (this.state.loading) {
                emojis.push(_react2.default.createElement(
                    'tr',
                    {
                        key: 'loading',
                        className: 'backstage-list__item backstage-list__empty'
                    },
                    _react2.default.createElement(
                        'td',
                        { colSpan: '4' },
                        _react2.default.createElement(_loading_screen2.default, { key: 'loading' })
                    )
                ));
            } else if (this.props.emojiIds.length === 0 || searchEmojis && searchEmojis.length === 0) {
                emojis.push(_react2.default.createElement(
                    'tr',
                    {
                        key: 'empty',
                        className: 'backstage-list__item backstage-list__empty'
                    },
                    _react2.default.createElement(
                        'td',
                        { colSpan: '4' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'emoji_list.empty',
                            defaultMessage: 'No custom emoji found'
                        })
                    )
                ));
            } else if (searchEmojis) {
                searchEmojis.forEach(function (emojiId) {
                    emojis.push(_react2.default.createElement(_emoji_list_item2.default, {
                        key: 'emoji_search_item' + emojiId,
                        emojiId: emojiId,
                        onDelete: _this4.deleteFromSearch
                    }));
                });
            } else {
                var pageStart = this.state.page * EMOJI_PER_PAGE;
                var pageEnd = pageStart + EMOJI_PER_PAGE;
                var emojisToDisplay = this.props.emojiIds.slice(pageStart, pageEnd);

                emojisToDisplay.forEach(function (emojiId) {
                    emojis.push(_react2.default.createElement(_emoji_list_item2.default, {
                        key: 'emoji_list_item' + emojiId,
                        emojiId: emojiId
                    }));
                });

                if (this.state.missingPages) {
                    var buttonContents = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'filtered_user_list.next',
                            defaultMessage: 'Next'
                        }),
                        _react2.default.createElement('i', { className: 'fa fa-chevron-right margin-left' })
                    );

                    nextButton = _react2.default.createElement(_save_button2.default, {
                        btnClass: 'btn-link',
                        extraClasses: 'pull-right',
                        onClick: this.nextPage,
                        saving: this.state.nextLoading,
                        disabled: this.state.nextLoading,
                        defaultMessage: buttonContents,
                        savingMessage: buttonContents
                    });
                }

                if (this.state.page > 0) {
                    previousButton = _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-link',
                            onClick: this.previousPage
                        },
                        _react2.default.createElement('i', { className: 'fa fa-chevron-left margin-right' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'filtered_user_list.prev',
                            defaultMessage: 'Previous'
                        })
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-filters' },
                    _react2.default.createElement(
                        'div',
                        { className: 'backstage-filter__search' },
                        _react2.default.createElement('i', { className: 'fa fa-search' }),
                        _react2.default.createElement('input', {
                            type: 'search',
                            className: 'form-control',
                            placeholder: (0, _utils.localizeMessage)('emoji_list.search', 'Search Custom Emoji'),
                            onChange: this.onSearchChange,
                            style: style.search
                        })
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'backstage-list__help' },
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'emoji_list.help',
                            defaultMessage: 'Custom emoji are available to everyone on your server. Type \':\' followed by two characters in a message box to bring up the emoji selection menu.'
                        })
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'emoji_list.help2',
                            defaultMessage: 'Tip: If you add #, ##, or ### as the first character on a new line containing emoji, you can use larger sized emoji. To try it out, send a message such as: \'# :smile:\'.'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-list' },
                    _react2.default.createElement(
                        'table',
                        { className: 'emoji-list__table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                { className: 'backstage-list__item emoji-list__table-header' },
                                _react2.default.createElement(
                                    'th',
                                    { className: 'emoji-list__name' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'emoji_list.name',
                                        defaultMessage: 'Name'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'emoji-list__image' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'emoji_list.image',
                                        defaultMessage: 'Image'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'emoji-list__creator' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'emoji_list.creator',
                                        defaultMessage: 'Creator'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { className: 'emoji-list_actions' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'emoji_list.actions',
                                        defaultMessage: 'Actions'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            emojis
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'filter-controls padding-top x2' },
                    previousButton,
                    nextButton
                )
            );
        }
    }]);
    return EmojiList;
}(_react2.default.Component);

EmojiList.propTypes = {

    /**
     * Custom emojis on the system.
     */
    emojiIds: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,

    /**
     * Function to scroll list to top.
     */
    scrollToTop: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Get pages of custom emojis.
         */
        getCustomEmojis: _propTypes2.default.func.isRequired,

        /**
         * Search custom emojis.
         */
        searchCustomEmojis: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = EmojiList;


var style = {
    search: { flexGrow: 0, flexShrink: 0 }
};

/***/ }),

/***/ 1908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(777);

var _emojis = __webpack_require__(853);

var _utils = __webpack_require__(762);

var _emoji_list_item = __webpack_require__(1909);

var _emoji_list_item2 = _interopRequireDefault(_emoji_list_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var emoji = state.entities.emojis.customEmoji[ownProps.emojiId];
    var creator = (0, _users.getUser)(state, emoji.creator_id) || {};

    return {
        emoji: emoji,
        creatorDisplayName: (0, _utils.getDisplayNameByUser)(creator),
        creatorUsername: creator.username,
        currentUserId: (0, _users.getCurrentUserId)(state),
        isSystemAdmin: (0, _users.isCurrentUserSystemAdmin)(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            deleteCustomEmoji: _emojis.deleteCustomEmoji
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_emoji_list_item2.default);

/***/ }),

/***/ 1909:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _client = __webpack_require__(270);

var _delete_emoji_modal = __webpack_require__(1910);

var _delete_emoji_modal2 = _interopRequireDefault(_delete_emoji_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmojiListItem = function (_React$Component) {
    (0, _inherits3.default)(EmojiListItem, _React$Component);

    function EmojiListItem() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, EmojiListItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmojiListItem.__proto__ || (0, _getPrototypeOf2.default)(EmojiListItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function () {
            if (_this.props.onDelete) {
                _this.props.onDelete(_this.props.emoji.id);
            }

            _this.props.actions.deleteCustomEmoji(_this.props.emoji.id);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(EmojiListItem, [{
        key: 'render',
        value: function render() {
            var emoji = this.props.emoji;
            var creatorUsername = this.props.creatorUsername;
            var creatorDisplayName = this.props.creatorDisplayName;

            if (creatorUsername && creatorUsername !== creatorDisplayName) {
                creatorDisplayName += ' (@' + creatorUsername + ')';
            }

            var deleteButton = null;
            if (this.props.isSystemAdmin || emoji.creator_id === this.props.currentUserId) {
                deleteButton = _react2.default.createElement(_delete_emoji_modal2.default, { onDelete: this.handleDelete });
            }

            return _react2.default.createElement(
                'tr',
                { className: 'backstage-list__item' },
                _react2.default.createElement(
                    'td',
                    { className: 'emoji-list__name' },
                    ':' + emoji.name + ':'
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'emoji-list__image' },
                    _react2.default.createElement('span', {
                        className: 'emoticon',
                        style: { backgroundImage: 'url(' + _client.Client4.getCustomEmojiImageUrl(emoji.id) + ')' }
                    })
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'emoji-list__creator' },
                    creatorDisplayName
                ),
                _react2.default.createElement(
                    'td',
                    { className: 'emoji-list-item_actions' },
                    deleteButton
                )
            );
        }
    }]);
    return EmojiListItem;
}(_react2.default.Component);

EmojiListItem.propTypes = {

    /*
     * Emoji to display.
     */
    emoji: _propTypes2.default.object.isRequired,

    /*
     * Logged in user's ID.
     */
    currentUserId: _propTypes2.default.string.isRequired,

    /*
     * Emoji creator name to display.
     */
    creatorDisplayName: _propTypes2.default.string.isRequired,

    /*
     * Emoji creator username to display if different from creatorDisplayName.
     */
    creatorUsername: _propTypes2.default.string,

    /*
     * Set if logged in user is system admin.
     */
    isSystemAdmin: _propTypes2.default.bool,

    /*
     * Function to call when emoji is deleted.
     */
    onDelete: _propTypes2.default.func,

    actions: _propTypes2.default.shape({

        /**
         * Delete a custom emoji.
         */
        deleteCustomEmoji: _propTypes2.default.func.isRequired
    }).isRequired
};
EmojiListItem.defaultProps = {
    emoji: {},
    currentUserId: '',
    creatorDisplayName: '',
    isSystemAdmin: false
};
exports.default = EmojiListItem;

/***/ }),

/***/ 1910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _delete_modal_trigger = __webpack_require__(1302);

var _delete_modal_trigger2 = _interopRequireDefault(_delete_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.
var DeleteEmoji = function (_DeleteModalTrigger) {
    (0, _inherits3.default)(DeleteEmoji, _DeleteModalTrigger);

    function DeleteEmoji() {
        (0, _classCallCheck3.default)(this, DeleteEmoji);
        return (0, _possibleConstructorReturn3.default)(this, (DeleteEmoji.__proto__ || (0, _getPrototypeOf2.default)(DeleteEmoji)).apply(this, arguments));
    }

    (0, _createClass3.default)(DeleteEmoji, [{
        key: 'triggerTitle',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'emoji_list.delete',
                defaultMessage: 'Delete'
            });
        }
    }, {
        key: 'modalTitle',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'emoji_list.delete.confirm.title',
                defaultMessage: 'Delete Custom Emoji'
            });
        }
    }, {
        key: 'modalMessage',
        get: function get() {
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-warning' },
                _react2.default.createElement('i', { className: 'fa fa-warning fa-margin--right' }),
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'emoji_list.delete.confirm.msg',
                    defaultMessage: 'This action permanently deletes the custom emoji. Are you sure you want to delete it?'
                })
            );
        }
    }, {
        key: 'modalConfirmButton',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'emoji_list.delete.confirm.button',
                defaultMessage: 'Delete'
            });
        }
    }]);
    return DeleteEmoji;
}(_delete_modal_trigger2.default);

DeleteEmoji.propTypes = {
    onDelete: _propTypes2.default.func.isRequired
};
exports.default = DeleteEmoji;

/***/ }),

/***/ 1911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _emoji_actions = __webpack_require__(1036);

var EmojiActions = _interopRequireWildcard(_emoji_actions);

var _emoji_store = __webpack_require__(829);

var _emoji_store2 = _interopRequireDefault(_emoji_store);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _spinner_button = __webpack_require__(926);

var _spinner_button2 = _interopRequireDefault(_spinner_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddEmoji = function (_React$Component) {
    (0, _inherits3.default)(AddEmoji, _React$Component);

    function AddEmoji(props) {
        (0, _classCallCheck3.default)(this, AddEmoji);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddEmoji.__proto__ || (0, _getPrototypeOf2.default)(AddEmoji)).call(this, props));

        _this.handleSubmit = _this.handleSubmit.bind(_this);

        _this.updateName = _this.updateName.bind(_this);
        _this.updateImage = _this.updateImage.bind(_this);

        _this.state = {
            name: '',
            image: null,
            imageUrl: '',
            saving: false,
            error: null
        };
        return _this;
    }

    (0, _createClass3.default)(AddEmoji, [{
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            if (this.state.saving) {
                return;
            }

            this.setState({
                saving: true,
                error: null
            });

            var emoji = {
                creator_id: this.props.user.id,
                name: this.state.name.trim().toLowerCase()
            };

            // trim surrounding colons if the user accidentally included them in the name
            if (emoji.name.startsWith(':') && emoji.name.endsWith(':')) {
                emoji.name = emoji.name.substring(1, emoji.name.length - 1);
            }

            if (!emoji.name) {
                this.setState({
                    saving: false,
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_emoji.nameRequired',
                        defaultMessage: 'A name is required for the emoji'
                    })
                });

                return;
            } else if (/[^a-z0-9_-]/.test(emoji.name)) {
                this.setState({
                    saving: false,
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_emoji.nameInvalid',
                        defaultMessage: 'An emoji\'s name can only contain lowercase letters, numbers, and the symbols \'-\' and \'_\'.'
                    })
                });

                return;
            } else if (_emoji_store2.default.hasSystemEmoji(emoji.name)) {
                this.setState({
                    saving: false,
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_emoji.nameTaken',
                        defaultMessage: 'This name is already in use by a system emoji. Please choose another name.'
                    })
                });

                return;
            }

            if (!this.state.image) {
                this.setState({
                    saving: false,
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_emoji.imageRequired',
                        defaultMessage: 'An image is required for the emoji'
                    })
                });

                return;
            }

            EmojiActions.addEmoji(emoji, this.state.image, function () {
                _this2.props.history.push('/' + _this2.props.team.name + '/emoji');
            }, function (err) {
                _this2.setState({
                    saving: false,
                    error: err.message
                });
            });
        }
    }, {
        key: 'updateName',
        value: function updateName(e) {
            this.setState({
                name: e.target.value
            });
        }
    }, {
        key: 'updateImage',
        value: function updateImage(e) {
            var _this3 = this;

            if (e.target.files.length === 0) {
                this.setState({
                    image: null,
                    imageUrl: ''
                });

                return;
            }

            var image = e.target.files[0];

            var reader = new FileReader();
            reader.onload = function () {
                _this3.setState({
                    image: image,
                    imageUrl: reader.result
                });
            };
            reader.readAsDataURL(image);
        }
    }, {
        key: 'render',
        value: function render() {
            var filename = null;
            if (this.state.image) {
                filename = _react2.default.createElement(
                    'span',
                    { className: 'add-emoji__filename' },
                    this.state.image.name
                );
            }

            var preview = null;
            if (this.state.imageUrl) {
                preview = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'preview'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'add_emoji.preview',
                            defaultMessage: 'Preview'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-md-5 col-sm-8 add-emoji__preview' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'add_emoji.preview.sentence',
                            defaultMessage: 'This is a sentence with {image} in it.',
                            values: {
                                image: _react2.default.createElement('span', {
                                    className: 'emoticon',
                                    style: { backgroundImage: 'url(' + this.state.imageUrl + ')' }
                                })
                            }
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content row' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/emoji' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'emoji_list.header',
                            defaultMessage: 'Custom Emoji'
                        })
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'add_emoji.header',
                        defaultMessage: 'Add'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form' },
                    _react2.default.createElement(
                        'form',
                        {
                            className: 'form-horizontal',
                            onSubmit: this.handleSubmit
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'name'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_emoji.name',
                                    defaultMessage: 'Name'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement('input', {
                                    id: 'name',
                                    type: 'text',
                                    maxLength: '64',
                                    className: 'form-control',
                                    value: this.state.name,
                                    onChange: this.updateName
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'form__help' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'add_emoji.name.help',
                                        defaultMessage: 'Choose a name for your emoji made of up to 64 characters consisting of lowercase letters, numbers, and the symbols \'-\' and \'_\'.'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'control-label col-sm-4',
                                    htmlFor: 'image'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_emoji.image',
                                    defaultMessage: 'Image'
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'col-md-5 col-sm-8' },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'add-emoji__upload' },
                                        _react2.default.createElement(
                                            'button',
                                            { className: 'btn btn-primary' },
                                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                id: 'add_emoji.image.button',
                                                defaultMessage: 'Select'
                                            })
                                        ),
                                        _react2.default.createElement('input', {
                                            type: 'file',
                                            accept: '.jpg,.png,.gif',
                                            multiple: false,
                                            onChange: this.updateImage
                                        })
                                    ),
                                    filename,
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'form__help' },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'add_emoji.image.help',
                                            defaultMessage: 'Choose the image for your emoji. The image can be a gif, png, or jpeg file with a max size of 64 KB and dimensions up to 128 by 128 pixels.'
                                        })
                                    )
                                )
                            )
                        ),
                        preview,
                        _react2.default.createElement(
                            'div',
                            { className: 'backstage-form__footer' },
                            _react2.default.createElement(_form_error2.default, {
                                type: 'backstage',
                                error: this.state.error
                            }),
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    className: 'btn btn-sm',
                                    to: '/' + this.props.team.name + '/emoji'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_emoji.cancel',
                                    defaultMessage: 'Cancel'
                                })
                            ),
                            _react2.default.createElement(
                                _spinner_button2.default,
                                {
                                    className: 'btn btn-primary',
                                    type: 'submit',
                                    spinning: this.state.saving,
                                    onClick: this.handleSubmit
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'add_emoji.save',
                                    defaultMessage: 'Save'
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return AddEmoji;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

AddEmoji.propTypes = {
    team: _propTypes2.default.object,
    user: _propTypes2.default.object
};
AddEmoji.contextTypes = {
    router: _propTypes2.default.object.isRequired
};
exports.default = AddEmoji;

/***/ }),

/***/ 1912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var Actions = _interopRequireWildcard(_integrations);

var _channels = __webpack_require__(783);

var _integrations2 = __webpack_require__(908);

var _teams = __webpack_require__(274);

var _users = __webpack_require__(777);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _installed_incoming_webhooks = __webpack_require__(1913);

var _installed_incoming_webhooks2 = _interopRequireDefault(_installed_incoming_webhooks);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var teamId = (0, _teams.getCurrentTeamId)(state);
    var canManageOthersWebhooks = (0, _roles.haveITeamPermission)(state, { team: teamId, permission: _constants.Permissions.MANAGE_OTHERS_WEBHOOKS });
    var incomingHooks = (0, _integrations2.getIncomingHooks)(state);
    var incomingWebhooks = (0, _keys2.default)(incomingHooks).map(function (key) {
        return incomingHooks[key];
    }).filter(function (incomingWebhook) {
        return incomingWebhook.team_id === teamId;
    });
    var enableIncomingWebhooks = config.EnableIncomingWebhooks === 'true';

    return {
        incomingWebhooks: incomingWebhooks,
        channels: (0, _channels.getAllChannels)(state),
        users: (0, _users.getUsers)(state),
        teamId: teamId,
        canManageOthersWebhooks: canManageOthersWebhooks,
        enableIncomingWebhooks: enableIncomingWebhooks
    };
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getIncomingHooks: Actions.getIncomingHooks,
            removeIncomingHook: Actions.removeIncomingHook
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_installed_incoming_webhooks2.default);

/***/ }),

/***/ 1913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _backstage_list = __webpack_require__(965);

var _backstage_list2 = _interopRequireDefault(_backstage_list);

var _installed_incoming_webhook = __webpack_require__(1914);

var _installed_incoming_webhook2 = _interopRequireDefault(_installed_incoming_webhook);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstalledIncomingWebhooks = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledIncomingWebhooks, _React$PureComponent);

    function InstalledIncomingWebhooks(props) {
        (0, _classCallCheck3.default)(this, InstalledIncomingWebhooks);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledIncomingWebhooks.__proto__ || (0, _getPrototypeOf2.default)(InstalledIncomingWebhooks)).call(this, props));

        _this.deleteIncomingWebhook = function (incomingWebhook) {
            _this.props.actions.removeIncomingHook(incomingWebhook.id);
        };

        _this.deleteIncomingWebhook = _this.deleteIncomingWebhook.bind(_this);
        _this.incomingWebhookCompare = _this.incomingWebhookCompare.bind(_this);
        _this.state = {
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(InstalledIncomingWebhooks, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.enableIncomingWebhooks) {
                this.props.actions.getIncomingHooks(this.props.teamId, _constants2.default.Integrations.START_PAGE_NUM, _constants2.default.Integrations.PAGE_SIZE).then(function () {
                    return _this2.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'incomingWebhookCompare',
        value: function incomingWebhookCompare(a, b) {
            var displayNameA = a.display_name;
            if (!displayNameA) {
                var channelA = this.props.channels[a.channel_id];
                if (channelA) {
                    displayNameA = channelA.display_name;
                } else {
                    displayNameA = Utils.localizeMessage('installed_incoming_webhooks.unknown_channel', 'A Private Webhook');
                }
            }

            var displayNameB = b.display_name;

            return displayNameA.localeCompare(displayNameB);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var incomingWebhooks = this.props.incomingWebhooks.sort(this.incomingWebhookCompare).map(function (incomingWebhook) {
                var canChange = _this3.props.canManageOthersWebhooks || _this3.props.user.id === incomingWebhook.user_id;
                var channel = _this3.props.channels[incomingWebhook.channel_id];
                return _react2.default.createElement(_installed_incoming_webhook2.default, {
                    key: incomingWebhook.id,
                    incomingWebhook: incomingWebhook,
                    onDelete: _this3.deleteIncomingWebhook,
                    creator: _this3.props.users[incomingWebhook.user_id] || {},
                    canChange: canChange,
                    team: _this3.props.team,
                    channel: channel
                });
            });

            return _react2.default.createElement(
                _backstage_list2.default,
                {
                    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_incoming_webhooks.header',
                        defaultMessage: 'Installed Incoming Webhooks'
                    }),
                    addText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_incoming_webhooks.add',
                        defaultMessage: 'Add Incoming Webhook'
                    }),
                    addLink: '/' + this.props.team.name + '/integrations/incoming_webhooks/add',
                    emptyText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_incoming_webhooks.empty',
                        defaultMessage: 'No incoming webhooks found'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_incoming_webhooks.help',
                        defaultMessage: 'Use incoming webhooks to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.',
                        values: {
                            buildYourOwn: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'http://docs.mattermost.com/developer/webhooks-incoming.html'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_incoming_webhooks.help.buildYourOwn',
                                    defaultMessage: 'Build your own'
                                })
                            ),
                            appDirectory: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://about.mattermost.com/default-app-directory/'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_incoming_webhooks.help.appDirectory',
                                    defaultMessage: 'App Directory'
                                })
                            )
                        }
                    }),
                    searchPlaceholder: Utils.localizeMessage('installed_incoming_webhooks.search', 'Search Incoming Webhooks'),
                    loading: this.state.loading
                },
                incomingWebhooks
            );
        }
    }]);
    return InstalledIncomingWebhooks;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

InstalledIncomingWebhooks.propTypes = {

    /**
    *  Data used in passing down as props for webhook modifications
    */
    team: _propTypes2.default.object,

    /**
    * Data used for checking if webhook is created by current user
    */
    user: _propTypes2.default.object,

    /**
    *  Data used for checking modification privileges
    */
    canManageOthersWebhooks: _propTypes2.default.bool,

    /**
    * Data used in passing down as props for showing webhook details
    */
    incomingWebhooks: _propTypes2.default.array,

    /**
    * Data used in sorting for displaying list and as props channel details
    */
    channels: _propTypes2.default.object,

    /**
    *  Data used in passing down as props for webhook -created by label
    */
    users: _propTypes2.default.object,

    /**
    *  Data used in passing as argument for loading webhooks
    */

    teamId: _propTypes2.default.string,
    actions: _propTypes2.default.shape({

        /**
        * The function to call for removing incomingWebhook
        */
        removeIncomingHook: _propTypes2.default.func,

        /**
        * The function to call for incomingWebhook List and for the status of api
        */
        getIncomingHooks: _propTypes2.default.func
    }),

    /**
    * Whether or not incoming webhooks are enabled.
    */
    enableIncomingWebhooks: _propTypes2.default.bool
};
exports.default = InstalledIncomingWebhooks;

/***/ }),

/***/ 1914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _url = __webpack_require__(793);

var _delete_integration = __webpack_require__(966);

var _delete_integration2 = _interopRequireDefault(_delete_integration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var InstalledIncomingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledIncomingWebhook, _React$PureComponent);

    function InstalledIncomingWebhook(props) {
        (0, _classCallCheck3.default)(this, InstalledIncomingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledIncomingWebhook.__proto__ || (0, _getPrototypeOf2.default)(InstalledIncomingWebhook)).call(this, props));

        _this.handleDelete = _this.handleDelete.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(InstalledIncomingWebhook, [{
        key: 'handleDelete',
        value: function handleDelete() {
            this.props.onDelete(this.props.incomingWebhook);
        }
    }, {
        key: 'render',
        value: function render() {
            var incomingWebhook = this.props.incomingWebhook;
            var channel = this.props.channel;
            var filter = this.props.filter ? this.props.filter.toLowerCase() : '';

            if (!InstalledIncomingWebhook.matchesFilter(incomingWebhook, channel, filter)) {
                return null;
            }

            var displayName = void 0;
            if (incomingWebhook.display_name) {
                displayName = incomingWebhook.display_name;
            } else if (channel) {
                displayName = channel.display_name;
            } else {
                displayName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_incoming_webhooks.unknown_channel',
                    defaultMessage: 'A Private Webhook'
                });
            }

            var description = null;
            if (incomingWebhook.description) {
                description = _react2.default.createElement(
                    'div',
                    { className: 'item-details__row' },
                    _react2.default.createElement(
                        'span',
                        { className: 'item-details__description' },
                        incomingWebhook.description
                    )
                );
            }

            var actions = null;
            if (this.props.canChange) {
                actions = _react2.default.createElement(
                    'div',
                    { className: 'item-actions' },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/incoming_webhooks/edit?id=' + incomingWebhook.id },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.edit',
                            defaultMessage: 'Edit'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(_delete_integration2.default, {
                        messageId: 'installed_incoming_webhooks.delete.confirm',
                        onDelete: this.handleDelete
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-list__item' },
                _react2.default.createElement(
                    'div',
                    { className: 'item-details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__name' },
                            displayName
                        )
                    ),
                    description,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__url' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.url',
                                defaultMessage: 'URL: {url}',
                                values: {
                                    url: (0, _url.getSiteURL)() + '/hooks/' + incomingWebhook.id
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__creation' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.creation',
                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
                                values: {
                                    creator: this.props.creator.username,
                                    createAt: incomingWebhook.create_at
                                }
                            })
                        )
                    )
                ),
                actions
            );
        }
    }], [{
        key: 'matchesFilter',
        value: function matchesFilter(incomingWebhook, channel, filter) {
            if (!filter) {
                return true;
            }

            if (incomingWebhook.display_name.toLowerCase().indexOf(filter) !== -1 || incomingWebhook.description.toLowerCase().indexOf(filter) !== -1) {
                return true;
            }

            if (incomingWebhook.channel_id) {
                if (channel && channel.name.toLowerCase().indexOf(filter) !== -1) {
                    return true;
                }
            }

            return false;
        }
    }]);
    return InstalledIncomingWebhook;
}(_react2.default.PureComponent);

InstalledIncomingWebhook.propTypes = {

    /**
    * Data used for showing webhook details
    */
    incomingWebhook: _propTypes2.default.object.isRequired,

    /**
    * Function to call when webhook delete button is pressed
    */
    onDelete: _propTypes2.default.func.isRequired,

    /**
    * String used for filtering webhook item
    */
    filter: _propTypes2.default.string,

    /**
    * Data used for showing created by details
    */
    creator: _propTypes2.default.object.isRequired,

    /**
    *  Set to show available actions on webhook
    */
    canChange: _propTypes2.default.bool.isRequired,

    /**
    *  Data used in routing of webhook for modifications
    */
    team: _propTypes2.default.object.isRequired,

    /**
    *  Data used for filtering of webhook based on filter prop
    */
    channel: _propTypes2.default.object
};
exports.default = InstalledIncomingWebhook;

/***/ }),

/***/ 1915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _general = __webpack_require__(113);

var _add_incoming_webhook = __webpack_require__(1916);

var _add_incoming_webhook2 = _interopRequireDefault(_add_incoming_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';
    var enablePostIconOverride = config.EnablePostIconOverride === 'true';

    return {
        createIncomingHookRequest: state.requests.integrations.createIncomingHook,
        enablePostUsernameOverride: enablePostUsernameOverride,
        enablePostIconOverride: enablePostIconOverride
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            createIncomingHook: _integrations.createIncomingHook
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_add_incoming_webhook2.default);

/***/ }),

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_history = __webpack_require__(273);

var _abstract_incoming_webhook = __webpack_require__(1303);

var _abstract_incoming_webhook2 = _interopRequireDefault(_abstract_incoming_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HEADER = { id: 'integrations.add', defaultMessage: 'Add' };
var FOOTER = { id: 'add_incoming_webhook.save', defaultMessage: 'Save' };

var AddIncomingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(AddIncomingWebhook, _React$PureComponent);

    function AddIncomingWebhook(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, AddIncomingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddIncomingWebhook.__proto__ || (0, _getPrototypeOf2.default)(AddIncomingWebhook)).call(this, props));

        _this.addIncomingHook = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(hook) {
                var _ref2, data;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.setState({ serverError: '' });

                                _context.next = 3;
                                return _this.props.actions.createIncomingHook(hook);

                            case 3:
                                _ref2 = _context.sent;
                                data = _ref2.data;

                                if (!data) {
                                    _context.next = 8;
                                    break;
                                }

                                _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/confirm?type=incoming_webhooks&id=' + data.id);
                                return _context.abrupt('return');

                            case 8:

                                if (_this.props.createIncomingHookRequest.error) {
                                    _this.setState({ serverError: _this.props.createIncomingHookRequest.error.message });
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(AddIncomingWebhook, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_abstract_incoming_webhook2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                enablePostUsernameOverride: this.props.enablePostUsernameOverride,
                enablePostIconOverride: this.props.enablePostIconOverride,
                action: this.addIncomingHook,
                serverError: this.state.serverError
            });
        }
    }]);
    return AddIncomingWebhook;
}(_react2.default.PureComponent);

AddIncomingWebhook.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The request state for createIncomingHook action. Contains status and error
    */
    createIncomingHookRequest: _propTypes2.default.object.isRequired,

    /**
    * Whether to allow configuration of the default post username.
    */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,

    /**
    * Whether to allow configuration of the default post icon.
    */
    enablePostIconOverride: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to add a new incoming webhook
        */
        createIncomingHook: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AddIncomingWebhook;

/***/ }),

/***/ 1917:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _general = __webpack_require__(113);

var _edit_incoming_webhook = __webpack_require__(1918);

var _edit_incoming_webhook2 = _interopRequireDefault(_edit_incoming_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var enableIncomingWebhooks = config.EnableIncomingWebhooks === 'true';
    var enablePostUsernameOverride = config.EnablePostUsernameOverride === 'true';
    var enablePostIconOverride = config.EnablePostIconOverride === 'true';
    var hookId = new URLSearchParams(ownProps.location.search).get('id');

    return {
        hookId: hookId,
        hook: state.entities.integrations.incomingHooks[hookId],
        updateIncomingHookRequest: state.requests.integrations.updateIncomingHook,
        enableIncomingWebhooks: enableIncomingWebhooks,
        enablePostUsernameOverride: enablePostUsernameOverride,
        enablePostIconOverride: enablePostIconOverride
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateIncomingHook: _integrations.updateIncomingHook,
            getIncomingHook: _integrations.getIncomingHook
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_incoming_webhook2.default);

/***/ }),

/***/ 1918:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_history = __webpack_require__(273);

var _abstract_incoming_webhook = __webpack_require__(1303);

var _abstract_incoming_webhook2 = _interopRequireDefault(_abstract_incoming_webhook);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER = { id: 'integrations.edit', defaultMessage: 'Edit' }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOOTER = { id: 'update_incoming_webhook.update', defaultMessage: 'Update' };

var EditIncomingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(EditIncomingWebhook, _React$PureComponent);

    function EditIncomingWebhook(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EditIncomingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditIncomingWebhook.__proto__ || (0, _getPrototypeOf2.default)(EditIncomingWebhook)).call(this, props));

        _this.editIncomingHook = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(hook) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.newHook = hook;

                                if (_this.props.hook.id) {
                                    hook.id = _this.props.hook.id;
                                }

                                if (_this.props.hook.token) {
                                    hook.token = _this.props.hook.token;
                                }

                                _context.next = 5;
                                return _this.submitHook();

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.submitHook = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _ref3, data;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this.setState({ serverError: '' });

                            _context2.next = 3;
                            return _this.props.actions.updateIncomingHook(_this.newHook);

                        case 3:
                            _ref3 = _context2.sent;
                            data = _ref3.data;

                            if (!data) {
                                _context2.next = 8;
                                break;
                            }

                            _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/incoming_webhooks');
                            return _context2.abrupt('return');

                        case 8:

                            if (_this.props.updateIncomingHookRequest.error) {
                                _this.setState({ serverError: _this.props.updateIncomingHookRequest.error.message });
                            }

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));


        _this.state = {
            showConfirmModal: false,
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(EditIncomingWebhook, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.enableIncomingWebhooks) {
                this.props.actions.getIncomingHook(this.props.hookId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.hook) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(_abstract_incoming_webhook2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                enablePostUsernameOverride: this.props.enablePostUsernameOverride,
                enablePostIconOverride: this.props.enablePostIconOverride,
                action: this.editIncomingHook,
                serverError: this.state.serverError,
                initialHook: this.props.hook
            });
        }
    }]);
    return EditIncomingWebhook;
}(_react2.default.PureComponent);

EditIncomingWebhook.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The incoming webhook to edit
    */
    hook: _propTypes2.default.object,

    /**
    * The id of the incoming webhook to edit
    */
    hookId: _propTypes2.default.string.isRequired,

    /**
    * The request state for updateIncomingHook action. Contains status and error
    */
    updateIncomingHookRequest: _propTypes2.default.object.isRequired,

    /**
    * Whether or not incoming webhooks are enabled.
    */
    enableIncomingWebhooks: _propTypes2.default.bool.isRequired,

    /**
    * Whether to allow configuration of the default post username.
    */
    enablePostUsernameOverride: _propTypes2.default.bool.isRequired,

    /**
    * Whether to allow configuration of the default post icon.
    */
    enablePostIconOverride: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to update an incoming webhook
        */
        updateIncomingHook: _propTypes2.default.func.isRequired,

        /**
        * The function to call to get an incoming webhook
        */
        getIncomingHook: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = EditIncomingWebhook;

/***/ }),

/***/ 1919:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var Actions = _interopRequireWildcard(_integrations);

var _integrations2 = __webpack_require__(908);

var _teams = __webpack_require__(274);

var _channels = __webpack_require__(783);

var _users = __webpack_require__(777);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _installed_outgoing_webhooks = __webpack_require__(1920);

var _installed_outgoing_webhooks2 = _interopRequireDefault(_installed_outgoing_webhooks);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var teamId = (0, _teams.getCurrentTeamId)(state);
    var canManageOthersWebhooks = (0, _roles.haveITeamPermission)(state, { team: teamId, permission: _constants.Permissions.MANAGE_OTHERS_WEBHOOKS });
    var outgoingHooks = (0, _integrations2.getOutgoingHooks)(state);
    var outgoingWebhooks = (0, _keys2.default)(outgoingHooks).map(function (key) {
        return outgoingHooks[key];
    }).filter(function (outgoingWebhook) {
        return outgoingWebhook.team_id === teamId;
    });
    var enableOutgoingWebhooks = config.EnableOutgoingWebhooks === 'true';

    return {
        outgoingWebhooks: outgoingWebhooks,
        channels: (0, _channels.getAllChannels)(state),
        users: (0, _users.getUsers)(state),
        teamId: teamId,
        canManageOthersWebhooks: canManageOthersWebhooks,
        enableOutgoingWebhooks: enableOutgoingWebhooks
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getOutgoingHooks: Actions.getOutgoingHooks,
            removeOutgoingHook: Actions.removeOutgoingHook,
            regenOutgoingHookToken: Actions.regenOutgoingHookToken
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_installed_outgoing_webhooks2.default);

/***/ }),

/***/ 1920:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _backstage_list = __webpack_require__(965);

var _backstage_list2 = _interopRequireDefault(_backstage_list);

var _installed_outgoing_webhook = __webpack_require__(1921);

var _installed_outgoing_webhook2 = _interopRequireDefault(_installed_outgoing_webhook);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstalledOutgoingWebhooks = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledOutgoingWebhooks, _React$PureComponent);

    function InstalledOutgoingWebhooks(props) {
        (0, _classCallCheck3.default)(this, InstalledOutgoingWebhooks);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledOutgoingWebhooks.__proto__ || (0, _getPrototypeOf2.default)(InstalledOutgoingWebhooks)).call(this, props));

        _this.regenOutgoingWebhookToken = function (outgoingWebhook) {
            _this.props.actions.regenOutgoingHookToken(outgoingWebhook.id);
        };

        _this.removeOutgoingHook = function (outgoingWebhook) {
            _this.props.actions.removeOutgoingHook(outgoingWebhook.id);
        };

        _this.outgoingWebhookCompare = _this.outgoingWebhookCompare.bind(_this);

        _this.state = {
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(InstalledOutgoingWebhooks, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.enableOutgoingWebhooks) {
                this.props.actions.getOutgoingHooks('', this.props.teamId, _constants2.default.Integrations.START_PAGE_NUM, _constants2.default.Integrations.PAGE_SIZE).then(function () {
                    return _this2.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'outgoingWebhookCompare',
        value: function outgoingWebhookCompare(a, b) {
            var displayNameA = a.display_name;
            if (!displayNameA) {
                var channelA = this.props.channels[a.channel_id];
                if (channelA) {
                    displayNameA = channelA.display_name;
                } else {
                    displayNameA = Utils.localizeMessage('installed_outgoing_webhooks.unknown_channel', 'A Private Webhook');
                }
            }

            var displayNameB = b.display_name;
            if (!displayNameB) {
                var channelB = this.props.channels[b.channel_id];
                if (channelB) {
                    displayNameB = channelB.display_name;
                } else {
                    displayNameB = Utils.localizeMessage('installed_outgoing_webhooks.unknown_channel', 'A Private Webhook');
                }
            }
            return displayNameA.localeCompare(displayNameB);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var outgoingWebhooks = this.props.outgoingWebhooks.sort(this.outgoingWebhookCompare).map(function (outgoingWebhook) {
                var canChange = _this3.props.canManageOthersWebhooks || _this3.props.user.id === outgoingWebhook.creator_id;
                var channel = _this3.props.channels[outgoingWebhook.channel_id];
                return _react2.default.createElement(_installed_outgoing_webhook2.default, {
                    key: outgoingWebhook.id,
                    outgoingWebhook: outgoingWebhook,
                    onRegenToken: _this3.regenOutgoingWebhookToken,
                    onDelete: _this3.removeOutgoingHook,
                    creator: _this3.props.users[outgoingWebhook.creator_id] || {},
                    canChange: canChange,
                    team: _this3.props.team,
                    channel: channel
                });
            });

            return _react2.default.createElement(
                _backstage_list2.default,
                {
                    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_outgoing_webhooks.header',
                        defaultMessage: 'Installed Outgoing Webhooks'
                    }),
                    addText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_outgoing_webhooks.add',
                        defaultMessage: 'Add Outgoing Webhook'
                    }),
                    addLink: '/' + this.props.team.name + '/integrations/outgoing_webhooks/add',
                    emptyText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_outgoing_webhooks.empty',
                        defaultMessage: 'No outgoing webhooks found'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_outgoing_webhooks.help',
                        defaultMessage: 'Use outgoing webhooks to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.',
                        values: {
                            buildYourOwn: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'http://docs.mattermost.com/developer/webhooks-outgoing.html'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_outgoing_webhooks.help.buildYourOwn',
                                    defaultMessage: 'Build your own'
                                })
                            ),
                            appDirectory: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://about.mattermost.com/default-app-directory/'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_outgoing_webhooks.help.appDirectory',
                                    defaultMessage: 'App Directory'
                                })
                            )
                        }
                    }),
                    searchPlaceholder: Utils.localizeMessage('installed_outgoing_webhooks.search', 'Search Outgoing Webhooks'),
                    loading: this.state.loading
                },
                outgoingWebhooks
            );
        }
    }]);
    return InstalledOutgoingWebhooks;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

InstalledOutgoingWebhooks.propTypes = {

    /**
    *  Data used in passing down as props for webhook modifications
    */
    team: _propTypes2.default.object,

    /**
    * Data used for checking if webhook is created by current user
    */
    user: _propTypes2.default.object,

    /**
    *  Data used for checking modification privileges
    */
    canManageOthersWebhooks: _propTypes2.default.bool,

    /**
    * Data used in passing down as props for showing webhook details
    */
    outgoingWebhooks: _propTypes2.default.array,

    /**
    * Data used in sorting for displaying list and as props channel details
    */
    channels: _propTypes2.default.object,

    /**
    *  Data used in passing down as props for webhook -created by label
    */
    users: _propTypes2.default.object,

    /**
    *  Data used in passing as argument for loading webhooks
    */
    teamId: _propTypes2.default.string,

    actions: _propTypes2.default.shape({

        /**
        * The function to call for removing outgoingWebhook
        */
        removeOutgoingHook: _propTypes2.default.func,

        /**
        * The function to call for outgoingWebhook List and for the status of api
        */
        getOutgoingHooks: _propTypes2.default.func,

        /**
        * The function to call for regeneration of webhook token
        */
        regenOutgoingHookToken: _propTypes2.default.func
    }),

    /**
    * Whether or not outgoing webhooks are enabled.
    */
    enableOutgoingWebhooks: _propTypes2.default.bool
};
exports.default = InstalledOutgoingWebhooks;

/***/ }),

/***/ 1921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _delete_integration = __webpack_require__(966);

var _delete_integration2 = _interopRequireDefault(_delete_integration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstalledOutgoingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledOutgoingWebhook, _React$PureComponent);

    function InstalledOutgoingWebhook(props) {
        (0, _classCallCheck3.default)(this, InstalledOutgoingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledOutgoingWebhook.__proto__ || (0, _getPrototypeOf2.default)(InstalledOutgoingWebhook)).call(this, props));

        _this.handleRegenToken = _this.handleRegenToken.bind(_this);
        _this.handleDelete = _this.handleDelete.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(InstalledOutgoingWebhook, [{
        key: 'handleRegenToken',
        value: function handleRegenToken(e) {
            e.preventDefault();

            this.props.onRegenToken(this.props.outgoingWebhook);
        }
    }, {
        key: 'handleDelete',
        value: function handleDelete() {
            this.props.onDelete(this.props.outgoingWebhook);
        }
    }, {
        key: 'makeDisplayName',
        value: function makeDisplayName(outgoingWebhook, channel) {
            if (outgoingWebhook.display_name) {
                return outgoingWebhook.display_name;
            } else if (channel) {
                return channel.display_name;
            }
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'installed_outgoing_webhooks.unknown_channel',
                defaultMessage: 'A Private Webhook'
            });
        }
    }, {
        key: 'matchesFilter',
        value: function matchesFilter(outgoingWebhook, channel, filter) {
            if (!filter) {
                return true;
            }

            var displayName = outgoingWebhook.display_name,
                description = outgoingWebhook.description,
                triggerWords = outgoingWebhook.trigger_words;


            if (displayName && displayName.toLowerCase().indexOf(filter) !== -1 || description && description.toLowerCase().indexOf(filter) !== -1) {
                return true;
            }

            if (triggerWords) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(triggerWords), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var triggerWord = _step.value;

                        if (triggerWord.toLowerCase().indexOf(filter) !== -1) {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            if (channel && channel.name) {
                if (channel.name.toLowerCase().indexOf(filter) !== -1) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var outgoingWebhook = this.props.outgoingWebhook;
            var channel = this.props.channel;
            var filter = this.props.filter ? this.props.filter.toLowerCase() : '';
            var triggerWordsFull = 0;
            var triggerWordsStartsWith = 1;

            if (outgoingWebhook && !this.matchesFilter(outgoingWebhook, channel, filter)) {
                return null;
            }

            var displayName = this.makeDisplayName(outgoingWebhook, channel);

            var description = null;
            if (outgoingWebhook.description) {
                description = _react2.default.createElement(
                    'div',
                    { className: 'item-details__row' },
                    _react2.default.createElement(
                        'span',
                        { className: 'item-details__description' },
                        outgoingWebhook.description
                    )
                );
            }

            var triggerWords = null;
            if (outgoingWebhook.trigger_words && outgoingWebhook.trigger_words.length > 0) {
                triggerWords = _react2.default.createElement(
                    'div',
                    { className: 'item-details__row' },
                    _react2.default.createElement(
                        'span',
                        { className: 'item-details__trigger-words' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.triggerWords',
                            defaultMessage: 'Trigger Words: {triggerWords}',
                            values: {
                                triggerWords: outgoingWebhook.trigger_words.join(', ')
                            }
                        })
                    )
                );
            }

            var urls = _react2.default.createElement(
                'div',
                { className: 'item-details__row' },
                _react2.default.createElement(
                    'span',
                    { className: 'item-details__url' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_integrations.callback_urls',
                        defaultMessage: 'Callback URLs: {urls}',
                        values: {
                            urls: outgoingWebhook.callback_urls.join(', ')
                        }
                    })
                )
            );

            var triggerWhen = void 0;
            if (outgoingWebhook.trigger_when === triggerWordsFull) {
                triggerWhen = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'add_outgoing_webhook.triggerWordsTriggerWhenFullWord',
                    defaultMessage: 'First word matches a trigger word exactly'
                });
            } else if (outgoingWebhook.trigger_when === triggerWordsStartsWith) {
                triggerWhen = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'add_outgoing_webhook.triggerWordsTriggerWhenStartsWith',
                    defaultMessage: 'First word starts with a trigger word'
                });
            }

            var actions = null;
            if (this.props.canChange) {
                actions = _react2.default.createElement(
                    'div',
                    { className: 'item-actions' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none color--link',
                            onClick: this.handleRegenToken
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.regenToken',
                            defaultMessage: 'Regen Token'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/outgoing_webhooks/edit?id=' + outgoingWebhook.id },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.edit',
                            defaultMessage: 'Edit'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(_delete_integration2.default, {
                        messageId: 'installed_outgoing_webhooks.delete.confirm',
                        onDelete: this.handleDelete
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-list__item' },
                _react2.default.createElement(
                    'div',
                    { className: 'item-details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__name' },
                            displayName
                        )
                    ),
                    description,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__content_type' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.content_type',
                                defaultMessage: 'Content-Type: {contentType}',
                                values: {
                                    contentType: outgoingWebhook.content_type || 'application/x-www-form-urlencoded'
                                }
                            })
                        )
                    ),
                    triggerWords,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__trigger-when' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.triggerWhen',
                                defaultMessage: 'Trigger When: {triggerWhen}',
                                values: {
                                    triggerWhen: triggerWhen
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__token' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.token',
                                defaultMessage: 'Token: {token}',
                                values: {
                                    token: outgoingWebhook.token
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__creation' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.creation',
                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
                                values: {
                                    creator: this.props.creator.username,
                                    createAt: outgoingWebhook.create_at
                                }
                            })
                        )
                    ),
                    urls
                ),
                actions
            );
        }
    }]);
    return InstalledOutgoingWebhook;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

InstalledOutgoingWebhook.propTypes = {

    /**
    * Data used for showing webhook details
    */
    outgoingWebhook: _propTypes2.default.object.isRequired,

    /**
    * Function used for webhook token regeneration
    */
    onRegenToken: _propTypes2.default.func.isRequired,

    /**
    * Function to call when webhook delete button is pressed
    */
    onDelete: _propTypes2.default.func.isRequired,

    /**
    * String used for filtering webhook item
    */
    filter: _propTypes2.default.string,

    /**
    * Data used for showing created by details
    */
    creator: _propTypes2.default.object.isRequired,

    /**
    *  Set to show available actions on webhook
    */
    canChange: _propTypes2.default.bool.isRequired,

    /**
    *  Data used in routing of webhook for modifications
    */
    team: _propTypes2.default.object.isRequired,

    /**
    *  Data used for filtering of webhooks based in filter prop
    */
    channel: _propTypes2.default.object
};
exports.default = InstalledOutgoingWebhook;

/***/ }),

/***/ 1922:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _add_outgoing_webhook = __webpack_require__(1923);

var _add_outgoing_webhook2 = _interopRequireDefault(_add_outgoing_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        createOutgoingHookRequest: state.requests.integrations.createOutgoingHook
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            createOutgoingHook: _integrations.createOutgoingHook
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_add_outgoing_webhook2.default);

/***/ }),

/***/ 1923:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_history = __webpack_require__(273);

var _abstract_outgoing_webhook = __webpack_require__(1305);

var _abstract_outgoing_webhook2 = _interopRequireDefault(_abstract_outgoing_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HEADER = { id: 'integrations.add', defaultMessage: 'Add' };
var FOOTER = { id: 'add_outgoing_webhook.save', defaultMessage: 'Save' };

var AddOutgoingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(AddOutgoingWebhook, _React$PureComponent);

    function AddOutgoingWebhook(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, AddOutgoingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddOutgoingWebhook.__proto__ || (0, _getPrototypeOf2.default)(AddOutgoingWebhook)).call(this, props));

        _this.addOutgoingHook = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(hook) {
                var _ref2, data;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.setState({ serverError: '' });

                                _context.next = 3;
                                return _this.props.actions.createOutgoingHook(hook);

                            case 3:
                                _ref2 = _context.sent;
                                data = _ref2.data;

                                if (!data) {
                                    _context.next = 8;
                                    break;
                                }

                                _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/confirm?type=outgoing_webhooks&id=' + data.id);
                                return _context.abrupt('return');

                            case 8:

                                if (_this.props.createOutgoingHookRequest.error) {
                                    _this.setState({ serverError: _this.props.createOutgoingHookRequest.error.message });
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(AddOutgoingWebhook, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_abstract_outgoing_webhook2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: '',
                action: this.addOutgoingHook,
                serverError: this.state.serverError
            });
        }
    }]);
    return AddOutgoingWebhook;
}(_react2.default.PureComponent);

AddOutgoingWebhook.propTypes = {

    /**
     * The current team
     */
    team: _propTypes2.default.object.isRequired,

    /**
     * The request state for createOutgoingHook action. Contains status and error
     */
    createOutgoingHookRequest: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * The function to call to add a new outgoing webhook
         */
        createOutgoingHook: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AddOutgoingWebhook;

/***/ }),

/***/ 1924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _general = __webpack_require__(113);

var _edit_outgoing_webhook = __webpack_require__(1925);

var _edit_outgoing_webhook2 = _interopRequireDefault(_edit_outgoing_webhook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var hookId = new URLSearchParams(ownProps.location.search).get('id');
    var enableOutgoingWebhooks = config.EnableOutgoingWebhooks === 'true';

    return {
        hookId: hookId,
        hook: state.entities.integrations.outgoingHooks[hookId],
        updateOutgoingHookRequest: state.requests.integrations.createOutgoingHook,
        enableOutgoingWebhooks: enableOutgoingWebhooks
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateOutgoingHook: _integrations.updateOutgoingHook,
            getOutgoingHook: _integrations.getOutgoingHook
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_outgoing_webhook2.default);

/***/ }),

/***/ 1925:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _abstract_outgoing_webhook = __webpack_require__(1305);

var _abstract_outgoing_webhook2 = _interopRequireDefault(_abstract_outgoing_webhook);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER = { id: 'integrations.edit', defaultMessage: 'Edit' }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOOTER = { id: 'update_outgoing_webhook.update', defaultMessage: 'Update' };

var EditOutgoingWebhook = function (_React$PureComponent) {
    (0, _inherits3.default)(EditOutgoingWebhook, _React$PureComponent);

    function EditOutgoingWebhook(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EditOutgoingWebhook);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditOutgoingWebhook.__proto__ || (0, _getPrototypeOf2.default)(EditOutgoingWebhook)).call(this, props));

        _this.editOutgoingHook = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(hook) {
                var triggerWordsSame, callbackUrlsSame;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.newHook = hook;

                                if (_this.props.hook.id) {
                                    hook.id = _this.props.hook.id;
                                }

                                if (_this.props.hook.token) {
                                    hook.token = _this.props.hook.token;
                                }

                                triggerWordsSame = _this.props.hook.trigger_words.length === hook.trigger_words.length && _this.props.hook.trigger_words.every(function (v, i) {
                                    return v === hook.trigger_words[i];
                                });
                                callbackUrlsSame = _this.props.hook.callback_urls.length === hook.callback_urls.length && _this.props.hook.callback_urls.every(function (v, i) {
                                    return v === hook.callback_urls[i];
                                });

                                if (!(_this.props.hook.content_type !== hook.content_type || !triggerWordsSame || !callbackUrlsSame)) {
                                    _context.next = 9;
                                    break;
                                }

                                _this.handleConfirmModal();
                                _context.next = 11;
                                break;

                            case 9:
                                _context.next = 11;
                                return _this.submitHook();

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleConfirmModal = function () {
            _this.setState({ showConfirmModal: true });
        };

        _this.confirmModalDismissed = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.submitHook = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _ref3, data;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this.setState({ serverError: '' });

                            _context2.next = 3;
                            return _this.props.actions.updateOutgoingHook(_this.newHook);

                        case 3:
                            _ref3 = _context2.sent;
                            data = _ref3.data;

                            if (!data) {
                                _context2.next = 8;
                                break;
                            }

                            _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/outgoing_webhooks');
                            return _context2.abrupt('return');

                        case 8:

                            _this.setState({ showConfirmModal: false });

                            if (_this.props.updateOutgoingHookRequest.error) {
                                _this.setState({ serverError: _this.props.updateOutgoingHookRequest.error.message });
                            }

                        case 10:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        _this.renderExtra = function () {
            var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_outgoing_webhook.update',
                defaultMessage: 'Update'
            });

            var confirmTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_outgoing_webhook.confirm',
                defaultMessage: 'Edit Outgoing Webhook'
            });

            var confirmMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_outgoing_webhook.question',
                defaultMessage: 'Your changes may break the existing outgoing webhook. Are you sure you would like to update it?'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                title: confirmTitle,
                message: confirmMessage,
                confirmButtonText: confirmButton,
                show: _this.state.showConfirmModal,
                onConfirm: _this.submitHook,
                onCancel: _this.confirmModalDismissed
            });
        };

        _this.state = {
            showConfirmModal: false,
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(EditOutgoingWebhook, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.enableOutgoingWebhooks) {
                this.props.actions.getOutgoingHook(this.props.hookId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.hook) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(_abstract_outgoing_webhook2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: this.renderExtra(),
                action: this.editOutgoingHook,
                serverError: this.state.serverError,
                initialHook: this.props.hook
            });
        }
    }]);
    return EditOutgoingWebhook;
}(_react2.default.PureComponent);

EditOutgoingWebhook.propTypes = {

    /**
     * The current team
     */
    team: _propTypes2.default.object.isRequired,

    /**
     * The outgoing webhook to edit
     */
    hook: _propTypes2.default.object,

    /**
     * The id of the outgoing webhook to edit
     */
    hookId: _propTypes2.default.string.isRequired,

    /**
     * The request state for updateOutgoingHook action. Contains status and error
     */
    updateOutgoingHookRequest: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * The function to call to update an outgoing webhook
         */
        updateOutgoingHook: _propTypes2.default.func.isRequired,

        /**
         * The function to call to get an outgoing webhook
         */
        getOutgoingHook: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
    * Whether or not outgoing webhooks are enabled.
    */
    enableOutgoingWebhooks: _propTypes2.default.bool
};
exports.default = EditOutgoingWebhook;

/***/ }),

/***/ 1926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var Actions = _interopRequireWildcard(_integrations);

var _integrations2 = __webpack_require__(908);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _general = __webpack_require__(113);

var _installed_oauth_apps = __webpack_require__(1927);

var _installed_oauth_apps2 = _interopRequireDefault(_installed_oauth_apps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';
    var enableOnlyAdminIntegrations = config.EnableOnlyAdminIntegrations === 'true';

    return {
        canManageOauth: (0, _roles.haveISystemPermission)(state, { permission: _constants.Permissions.MANAGE_OAUTH }),
        oauthApps: (0, _integrations2.getOAuthApps)(state),
        regenOAuthAppSecretRequest: state.requests.integrations.updateOAuthApp,
        enableOAuthServiceProvider: enableOAuthServiceProvider,
        enableOnlyAdminIntegrations: enableOnlyAdminIntegrations
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getOAuthApps: Actions.getOAuthApps,
            regenOAuthAppSecret: Actions.regenOAuthAppSecret,
            deleteOAuthApp: Actions.deleteOAuthApp
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_installed_oauth_apps2.default);

/***/ }),

/***/ 1927:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var _backstage_list = __webpack_require__(965);

var _backstage_list2 = _interopRequireDefault(_backstage_list);

var _installed_oauth_app = __webpack_require__(1928);

var _installed_oauth_app2 = _interopRequireDefault(_installed_oauth_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var InstalledOAuthApps = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledOAuthApps, _React$PureComponent);

    function InstalledOAuthApps(props) {
        (0, _classCallCheck3.default)(this, InstalledOAuthApps);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledOAuthApps.__proto__ || (0, _getPrototypeOf2.default)(InstalledOAuthApps)).call(this, props));

        _this.deleteOAuthApp = function (app) {
            if (app && app.id) {
                _this.props.actions.deleteOAuthApp(app.id);
            }
        };

        _this.state = {
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(InstalledOAuthApps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.enableOAuthServiceProvider) {
                this.props.actions.getOAuthApps().then(function () {
                    return _this2.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'oauthAppCompare',
        value: function oauthAppCompare(a, b) {
            var nameA = a.name;
            if (!nameA) {
                nameA = (0, _utils.localizeMessage)('installed_integrations.unnamed_oauth_app', 'Unnamed OAuth 2.0 Application');
            }

            var nameB = b.name;
            if (!nameB) {
                nameB = (0, _utils.localizeMessage)('installed_integrations.unnamed_oauth_app', 'Unnamed OAuth 2.0 Application');
            }

            return nameA.localeCompare(nameB);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var oauthApps = (0, _values2.default)(this.props.oauthApps).sort(this.oauthAppCompare).map(function (app) {
                return _react2.default.createElement(_installed_oauth_app2.default, {
                    key: app.id,
                    team: _this3.props.team,
                    oauthApp: app,
                    regenOAuthAppSecretRequest: _this3.props.regenOAuthAppSecretRequest,
                    onRegenerateSecret: _this3.props.actions.regenOAuthAppSecret,
                    onDelete: _this3.deleteOAuthApp
                });
            });

            var integrationsEnabled = this.props.enableOAuthServiceProvider && this.props.canManageOauth;
            var props = void 0;
            if (integrationsEnabled) {
                props = {
                    addLink: '/' + this.props.team.name + '/integrations/oauth2-apps/add',
                    addText: (0, _utils.localizeMessage)('installed_oauth_apps.add', 'Add OAuth 2.0 Application')
                };
            }

            return _react2.default.createElement(
                _backstage_list2.default,
                (0, _extends3.default)({
                    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_oauth_apps.header',
                        defaultMessage: 'OAuth 2.0 Applications'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_oauth_apps.help',
                        defaultMessage: 'Create {oauthApplications} to securely integrate bots and third-party apps with Mattermost. Visit the {appDirectory} to find available self-hosted apps.',
                        values: {
                            oauthApplications: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://docs.mattermost.com/developer/oauth-2-0-applications.html'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.help.oauthApplications',
                                    defaultMessage: 'OAuth 2.0 applications'
                                })
                            ),
                            appDirectory: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://about.mattermost.com/default-app-directory/'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_oauth_apps.help.appDirectory',
                                    defaultMessage: 'App Directory'
                                })
                            )
                        }
                    }),
                    emptyText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_oauth_apps.empty',
                        defaultMessage: 'No OAuth 2.0 Applications found'
                    }),
                    searchPlaceholder: (0, _utils.localizeMessage)('installed_oauth_apps.search', 'Search OAuth 2.0 Applications'),
                    loading: this.state.loading
                }, props),
                oauthApps
            );
        }
    }]);
    return InstalledOAuthApps;
}(_react2.default.PureComponent);

InstalledOAuthApps.propTypes = {

    /**
    * The team data
    */
    team: _propTypes2.default.object,

    /**
    * The oauthApps data
    */
    oauthApps: _propTypes2.default.object,

    /**
    * Set if user can manage oath
    */
    canManageOauth: _propTypes2.default.bool,

    /**
    * The request state for regenOAuthAppSecret action. Contains status and error
    */
    regenOAuthAppSecretRequest: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to fetch OAuth apps
        */
        getOAuthApps: _propTypes2.default.func.isRequired,

        /**
        * The function to call when Regenerate Secret link is clicked
        */
        regenOAuthAppSecret: _propTypes2.default.func.isRequired,

        /**
        * The function to call when Delete link is clicked
        */
        deleteOAuthApp: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
    * Whether or not OAuth applications are enabled.
    */
    enableOAuthServiceProvider: _propTypes2.default.bool,

    /**
    * Whether or not integration configuration is restricted to admins.
    */
    enableOnlyAdminIntegrations: _propTypes2.default.bool
};
exports.default = InstalledOAuthApps;

/***/ }),

/***/ 1928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _delete_integration = __webpack_require__(966);

var _delete_integration2 = _interopRequireDefault(_delete_integration);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAKE_SECRET = '***************'; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var InstalledOAuthApp = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledOAuthApp, _React$PureComponent);

    function InstalledOAuthApp(props) {
        (0, _classCallCheck3.default)(this, InstalledOAuthApp);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstalledOAuthApp.__proto__ || (0, _getPrototypeOf2.default)(InstalledOAuthApp)).call(this, props));

        _this.handleShowClientSecret = function (e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            _this.setState({ clientSecret: _this.props.oauthApp.client_secret });
        };

        _this.handleHideClientSecret = function (e) {
            e.preventDefault();
            _this.setState({ clientSecret: FAKE_SECRET });
        };

        _this.handleRegenerate = function (e) {
            e.preventDefault();
            _this.props.onRegenerateSecret(_this.props.oauthApp.id).then(function () {
                var error = _this.props.regenOAuthAppSecretRequest.error;

                if (error) {
                    _this.setState({ error: error.message });
                } else {
                    _this.setState({ error: null });
                    _this.handleShowClientSecret();
                }
            });
        };

        _this.handleDelete = function () {
            _this.props.onDelete(_this.props.oauthApp);
        };

        _this.matchesFilter = function (oauthApp, filter) {
            if (!filter) {
                return true;
            }

            return oauthApp.name.toLowerCase().indexOf(filter) !== -1;
        };

        _this.state = {
            clientSecret: FAKE_SECRET
        };
        return _this;
    }

    (0, _createClass3.default)(InstalledOAuthApp, [{
        key: 'render',
        value: function render() {
            var oauthApp = this.props.oauthApp;
            var error = void 0;

            if (this.state.error) {
                error = _react2.default.createElement(_form_error2.default, {
                    error: this.state.error
                });
            }

            if (!this.matchesFilter(oauthApp, this.props.filter)) {
                return null;
            }

            var name = void 0;
            if (oauthApp.name) {
                name = oauthApp.name;
            } else {
                name = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_integrations.unnamed_oauth_app',
                    defaultMessage: 'Unnamed OAuth 2.0 Application'
                });
            }

            var description = void 0;
            if (oauthApp.description) {
                description = _react2.default.createElement(
                    'div',
                    { className: 'item-details__row' },
                    _react2.default.createElement(
                        'span',
                        { className: 'item-details__description' },
                        oauthApp.description
                    )
                );
            }

            var urls = _react2.default.createElement(
                'div',
                { className: 'item-details__row' },
                _react2.default.createElement(
                    'span',
                    { className: 'item-details__url' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_integrations.callback_urls',
                        defaultMessage: 'Callback URLs: {urls}',
                        values: {
                            urls: oauthApp.callback_urls.join(', ')
                        }
                    })
                )
            );

            var isTrusted = void 0;
            if (oauthApp.is_trusted) {
                isTrusted = Utils.localizeMessage('installed_oauth_apps.trusted.yes', 'Yes');
            } else {
                isTrusted = Utils.localizeMessage('installed_oauth_apps.trusted.no', 'No');
            }

            var showHide = void 0;
            if (this.state.clientSecret === FAKE_SECRET) {
                showHide = _react2.default.createElement(
                    'button',
                    {
                        id: 'showSecretButton',
                        className: 'style--none color--link',
                        onClick: this.handleShowClientSecret
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_integrations.showSecret',
                        defaultMessage: 'Show Secret'
                    })
                );
            } else {
                showHide = _react2.default.createElement(
                    'button',
                    {
                        id: 'hideSecretButton',
                        className: 'style--none color--link',
                        onClick: this.handleHideClientSecret
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_integrations.hideSecret',
                        defaultMessage: 'Hide Secret'
                    })
                );
            }

            var regen = _react2.default.createElement(
                'button',
                {
                    id: 'regenerateSecretButton',
                    className: 'style--none color--link',
                    onClick: this.handleRegenerate
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_integrations.regenSecret',
                    defaultMessage: 'Regenerate Secret'
                })
            );

            var icon = void 0;
            if (oauthApp.icon_url) {
                icon = _react2.default.createElement(
                    'div',
                    { className: 'integration__icon integration-list__icon' },
                    _react2.default.createElement('img', { src: oauthApp.icon_url })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-list__item' },
                icon,
                _react2.default.createElement(
                    'div',
                    { className: 'item-details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__name' },
                            name
                        )
                    ),
                    error,
                    description,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__url' },
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'installed_oauth_apps.is_trusted',
                                defaultMessage: 'Is Trusted: <strong>{isTrusted}</strong>',
                                values: {
                                    isTrusted: isTrusted
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__token' },
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'installed_integrations.client_id',
                                defaultMessage: 'Client ID: <strong>{clientId}</strong>',
                                values: {
                                    clientId: oauthApp.id
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__token' },
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'installed_integrations.client_secret',
                                defaultMessage: 'Client Secret: <strong>{clientSecret}</strong>',
                                values: {
                                    clientSecret: this.state.clientSecret
                                }
                            })
                        )
                    ),
                    urls,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__creation' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.creation',
                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
                                values: {
                                    creator: Utils.getDisplayNameByUserId(oauthApp.creator_id),
                                    createAt: oauthApp.create_at
                                }
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'item-actions' },
                    showHide,
                    ' - ',
                    regen,
                    ' - ',
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/oauth2-apps/edit?id=' + oauthApp.id },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.edit',
                            defaultMessage: 'Edit'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(_delete_integration2.default, {
                        messageId: 'installed_oauth_apps.delete.confirm',
                        onDelete: this.handleDelete
                    })
                )
            );
        }
    }]);
    return InstalledOAuthApp;
}(_react2.default.PureComponent);

InstalledOAuthApp.propTypes = {

    /**
    * The team data
    */
    team: _propTypes2.default.object,

    /**
    * The oauthApp data
    */
    oauthApp: _propTypes2.default.object.isRequired,

    /**
    * The request state for regenOAuthAppSecret action. Contains status and error
    */
    regenOAuthAppSecretRequest: _propTypes2.default.object.isRequired,

    /**
    * The function to call when Regenerate Secret link is clicked
    */
    onRegenerateSecret: _propTypes2.default.func.isRequired,

    /**
    * The function to call when Delete link is clicked
    */
    onDelete: _propTypes2.default.func.isRequired,

    /**
    * Set to filter OAuthApp
    */
    filter: _propTypes2.default.string
};
exports.default = InstalledOAuthApp;

/***/ }),

/***/ 1929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _add_oauth_app = __webpack_require__(1930);

var _add_oauth_app2 = _interopRequireDefault(_add_oauth_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        addOAuthAppRequest: state.requests.integrations.addOAuthApp
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addOAuthApp: _integrations.addOAuthApp
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_add_oauth_app2.default);

/***/ }),

/***/ 1930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_history = __webpack_require__(273);

var _abstract_oauth_app = __webpack_require__(1306);

var _abstract_oauth_app2 = _interopRequireDefault(_abstract_oauth_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HEADER = { id: 'add_oauth_app.header', defaultMessage: 'Add' };
var FOOTER = { id: 'installed_oauth_apps.save', defaultMessage: 'Save' };

var AddOAuthApp = function (_React$PureComponent) {
    (0, _inherits3.default)(AddOAuthApp, _React$PureComponent);

    function AddOAuthApp(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, AddOAuthApp);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddOAuthApp.__proto__ || (0, _getPrototypeOf2.default)(AddOAuthApp)).call(this, props));

        _this.addOAuthApp = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(app) {
                var _ref2, data;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.setState({ serverError: '' });

                                _context.next = 3;
                                return _this.props.actions.addOAuthApp(app);

                            case 3:
                                _ref2 = _context.sent;
                                data = _ref2.data;

                                if (!data) {
                                    _context.next = 8;
                                    break;
                                }

                                _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/confirm?type=oauth2-apps&id=' + data.id);
                                return _context.abrupt('return');

                            case 8:

                                if (_this.props.addOAuthAppRequest.error) {
                                    _this.setState({ serverError: _this.props.addOAuthAppRequest.error.message });
                                }

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(AddOAuthApp, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_abstract_oauth_app2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: '',
                action: this.addOAuthApp,
                serverError: this.state.serverError
            });
        }
    }]);
    return AddOAuthApp;
}(_react2.default.PureComponent);

AddOAuthApp.propTypes = {

    /**
    * The team data
    */
    team: _propTypes2.default.object,

    /**
    * The request state for addOAuthApp action. Contains status and error
    */
    addOAuthAppRequest: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to add new OAuthApp
        */
        addOAuthApp: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AddOAuthApp;

/***/ }),

/***/ 1931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _general = __webpack_require__(113);

var _edit_oauth_app = __webpack_require__(1932);

var _edit_oauth_app2 = _interopRequireDefault(_edit_oauth_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var oauthAppId = new URLSearchParams(ownProps.location.search).get('id');
    var enableOAuthServiceProvider = config.EnableOAuthServiceProvider === 'true';

    return {
        oauthAppId: oauthAppId,
        oauthApp: state.entities.integrations.oauthApps[oauthAppId],
        enableOAuthServiceProvider: enableOAuthServiceProvider
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getOAuthApp: _integrations.getOAuthApp,
            editOAuthApp: _integrations.editOAuthApp
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_oauth_app2.default);

/***/ }),

/***/ 1932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _abstract_oauth_app = __webpack_require__(1306);

var _abstract_oauth_app2 = _interopRequireDefault(_abstract_oauth_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER = { id: 'integrations.edit', defaultMessage: 'Edit' }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOOTER = { id: 'update_incoming_webhook.update', defaultMessage: 'Update' };

var EditOAuthApp = function (_React$PureComponent) {
    (0, _inherits3.default)(EditOAuthApp, _React$PureComponent);

    function EditOAuthApp(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EditOAuthApp);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditOAuthApp.__proto__ || (0, _getPrototypeOf2.default)(EditOAuthApp)).call(this, props));

        _this.editOAuthApp = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(app) {
                var callbackUrlsSame;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.newApp = app;

                                if (_this.props.oauthApp.id) {
                                    app.id = _this.props.oauthApp.id;
                                }

                                if (_this.props.oauthApp.token) {
                                    app.token = _this.props.oauthApp.token;
                                }

                                callbackUrlsSame = _this.props.oauthApp.callback_urls.length === app.callback_urls.length && _this.props.oauthApp.callback_urls.every(function (v, i) {
                                    return v === app.callback_urls[i];
                                });

                                if (!(callbackUrlsSame === false)) {
                                    _context.next = 8;
                                    break;
                                }

                                _this.handleConfirmModal();
                                _context.next = 10;
                                break;

                            case 8:
                                _context.next = 10;
                                return _this.submitOAuthApp();

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleConfirmModal = function () {
            _this.setState({ showConfirmModal: true });
        };

        _this.confirmModalDismissed = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.submitOAuthApp = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _ref3, data, error;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this.setState({ serverError: '' });

                            _context2.next = 3;
                            return _this.props.actions.editOAuthApp(_this.newApp);

                        case 3:
                            _ref3 = _context2.sent;
                            data = _ref3.data;
                            error = _ref3.error;

                            if (!data) {
                                _context2.next = 9;
                                break;
                            }

                            _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/oauth2-apps');
                            return _context2.abrupt('return');

                        case 9:

                            _this.setState({ showConfirmModal: false });

                            if (error) {
                                _this.setState({ serverError: error.message });
                            }

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        _this.renderExtra = function () {
            var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_command.update',
                defaultMessage: 'Update'
            });

            var confirmTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_oauth_app.confirm',
                defaultMessage: 'Edit OAuth 2.0 application'
            });

            var confirmMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_oauth_app.question',
                defaultMessage: 'Your changes may break the existing OAuth 2.0 application. Are you sure you would like to update it?'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                title: confirmTitle,
                message: confirmMessage,
                confirmButtonText: confirmButton,
                show: _this.state.showConfirmModal,
                onConfirm: _this.submitOAuthApp,
                onCancel: _this.confirmModalDismissed
            });
        };

        _this.state = {
            showConfirmModal: false,
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(EditOAuthApp, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.enableOAuthServiceProvider) {
                this.props.actions.getOAuthApp(this.props.oauthAppId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.oauthApp) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(_abstract_oauth_app2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: this.renderExtra(),
                action: this.editOAuthApp,
                serverError: this.state.serverError,
                initialApp: this.props.oauthApp
            });
        }
    }]);
    return EditOAuthApp;
}(_react2.default.PureComponent);

EditOAuthApp.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The id of the OAuthApp to edit
    */
    oauthAppId: _propTypes2.default.string.isRequired,

    /**
    * The OAuthApp data
    */
    oauthApp: _propTypes2.default.object,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to get OAuthApp
        */
        getOAuthApp: _propTypes2.default.func.isRequired,

        /**
        * The function to call to edit OAuthApp
        */
        editOAuthApp: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
    * Whether or not OAuth applications are enabled.
    */
    enableOAuthServiceProvider: _propTypes2.default.bool
};
exports.default = EditOAuthApp;

/***/ }),

/***/ 1933:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _integrations2 = __webpack_require__(908);

var _users = __webpack_require__(777);

var _general = __webpack_require__(113);

var _commands_container = __webpack_require__(1934);

var _commands_container2 = _interopRequireDefault(_commands_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var enableCommands = config.EnableCommands === 'true';

    return {
        commands: (0, _values2.default)((0, _integrations2.getCommands)(state)),
        users: (0, _users.getUsers)(state),
        enableCommands: enableCommands
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getCustomTeamCommands: _integrations.getCustomTeamCommands
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_commands_container2.default);

/***/ }),

/***/ 1934:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _installed_commands = __webpack_require__(1935);

var _installed_commands2 = _interopRequireDefault(_installed_commands);

var _add_command = __webpack_require__(1938);

var _add_command2 = _interopRequireDefault(_add_command);

var _edit_command = __webpack_require__(1940);

var _edit_command2 = _interopRequireDefault(_edit_command);

var _confirm_integration = __webpack_require__(1308);

var _confirm_integration2 = _interopRequireDefault(_confirm_integration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommandRoute = function CommandRoute(_ref) {
    var Component = _ref.component,
        extraProps = _ref.extraProps,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component', 'extraProps']);
    return (//eslint-disable-line react/prop-types
        _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
            render: function render(props) {
                return _react2.default.createElement(Component, (0, _extends3.default)({}, extraProps, props));
            }
        }))
    );
}; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CommandsContainer = function (_React$PureComponent) {
    (0, _inherits3.default)(CommandsContainer, _React$PureComponent);

    function CommandsContainer(props) {
        (0, _classCallCheck3.default)(this, CommandsContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CommandsContainer.__proto__ || (0, _getPrototypeOf2.default)(CommandsContainer)).call(this, props));

        _this.state = {
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(CommandsContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.enableCommands) {
                this.props.actions.getCustomTeamCommands(this.props.team.id).then(function () {
                    return _this2.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var extraProps = {
                loading: this.state.loading,
                commands: this.props.commands || [],
                users: this.props.users,
                team: this.props.team,
                user: this.props.user
            };
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactRouterDom.Switch,
                    null,
                    _react2.default.createElement(_reactRouterDom.Route, {
                        exact: true,
                        path: this.props.match.url + '/',
                        render: function render() {
                            return _react2.default.createElement(_reactRouterDom.Redirect, { to: _this3.props.match.url + '/installed' });
                        }
                    }),
                    _react2.default.createElement(CommandRoute, {
                        extraProps: extraProps,
                        path: this.props.match.url + '/installed',
                        component: _installed_commands2.default
                    }),
                    _react2.default.createElement(CommandRoute, {
                        extraProps: extraProps,
                        path: this.props.match.url + '/add',
                        component: _add_command2.default
                    }),
                    _react2.default.createElement(CommandRoute, {
                        extraProps: extraProps,
                        path: this.props.match.url + '/edit',
                        component: _edit_command2.default
                    }),
                    _react2.default.createElement(CommandRoute, {
                        extraProps: extraProps,
                        path: this.props.match.url + '/confirm',
                        component: _confirm_integration2.default
                    })
                )
            );
        }
    }]);
    return CommandsContainer;
}(_react2.default.PureComponent);

CommandsContainer.propTypes = {

    /**
    * The team data needed to pass into child components
    */
    team: _propTypes2.default.object,

    /**
    * The user data needed to pass into child components
    */
    user: _propTypes2.default.object,

    /**
    * The users collection
    */
    users: _propTypes2.default.object,

    /**
    * Installed slash commands to display
    */
    commands: _propTypes2.default.array,

    /**
    * Object from react-router
    */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to fetch team commands
        */
        getCustomTeamCommands: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
    * Whether or not commands are enabled.
    */
    enableCommands: _propTypes2.default.bool
};
exports.default = CommandsContainer;

/***/ }),

/***/ 1935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _roles = __webpack_require__(276);

var _constants = __webpack_require__(19);

var _installed_commands = __webpack_require__(1936);

var _installed_commands2 = _interopRequireDefault(_installed_commands);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var canManageOthersSlashCommands = (0, _roles.haveITeamPermission)(state, { team: ownProps.team.id, permission: _constants.Permissions.MANAGE_OTHERS_SLASH_COMMANDS });

    return {
        canManageOthersSlashCommands: canManageOthersSlashCommands
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            regenCommandToken: _integrations.regenCommandToken,
            deleteCommand: _integrations.deleteCommand
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_installed_commands2.default);

/***/ }),

/***/ 1936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _backstage_list = __webpack_require__(965);

var _backstage_list2 = _interopRequireDefault(_backstage_list);

var _installed_command = __webpack_require__(1937);

var _installed_command2 = _interopRequireDefault(_installed_command);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var InstalledCommands = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledCommands, _React$PureComponent);

    function InstalledCommands() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, InstalledCommands);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InstalledCommands.__proto__ || (0, _getPrototypeOf2.default)(InstalledCommands)).call.apply(_ref, [this].concat(args))), _this), _this.regenCommandToken = function (command) {
            _this.props.actions.regenCommandToken(command.id);
        }, _this.deleteCommand = function (command) {
            _this.props.actions.deleteCommand(command.id);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(InstalledCommands, [{
        key: 'commandCompare',
        value: function commandCompare(a, b) {
            var nameA = a.display_name;
            if (!nameA) {
                nameA = Utils.localizeMessage('installed_commands.unnamed_command', 'Unnamed Slash Command');
            }

            var nameB = b.display_name;
            if (!nameB) {
                nameB = Utils.localizeMessage('installed_commands.unnamed_command', 'Unnamed Slash Command');
            }

            return nameA.localeCompare(nameB);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var commands = this.props.commands.filter(function (command) {
                return command.team_id === _this2.props.team.id;
            }).sort(this.commandCompare).map(function (command) {
                var canChange = _this2.props.canManageOthersSlashCommands || _this2.props.user.id === command.creator_id;

                return _react2.default.createElement(_installed_command2.default, {
                    key: command.id,
                    team: _this2.props.team,
                    command: command,
                    onRegenToken: _this2.regenCommandToken,
                    onDelete: _this2.deleteCommand,
                    creator: _this2.props.users[command.creator_id] || {},
                    canChange: canChange
                });
            });

            return _react2.default.createElement(
                _backstage_list2.default,
                {
                    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_commands.header',
                        defaultMessage: 'Installed Slash Commands'
                    }),
                    addText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_commands.add',
                        defaultMessage: 'Add Slash Command'
                    }),
                    addLink: '/' + this.props.team.name + '/integrations/commands/add',
                    emptyText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_commands.empty',
                        defaultMessage: 'No slash commands found'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_commands.help',
                        defaultMessage: 'Use slash commands to connect external tools to Mattermost. {buildYourOwn} or visit the {appDirectory} to find self-hosted, third-party apps and integrations.',
                        values: {
                            buildYourOwn: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'http://docs.mattermost.com/developer/slash-commands.html'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_commands.help.buildYourOwn',
                                    defaultMessage: 'Build your own'
                                })
                            ),
                            appDirectory: _react2.default.createElement(
                                'a',
                                {
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    href: 'https://about.mattermost.com/default-app-directory/'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'installed_commands.help.appDirectory',
                                    defaultMessage: 'App Directory'
                                })
                            )
                        }
                    }),
                    searchPlaceholder: Utils.localizeMessage('installed_commands.search', 'Search Slash Commands'),
                    loading: this.props.loading
                },
                commands
            );
        }
    }]);
    return InstalledCommands;
}(_react2.default.PureComponent);

InstalledCommands.propTypes = {

    /**
    * The team object
    */
    team: _propTypes2.default.object,

    /**
    * The user object
    */
    user: _propTypes2.default.object,

    /**
    * The users collection
    */
    users: _propTypes2.default.object,

    /**
    * Installed slash commands to display
    */
    commands: _propTypes2.default.array,

    /**
    * Set whether to show the loading... animation or not
    */
    loading: _propTypes2.default.bool,

    /**
    * Set to allow changes to installed slash commands
    */
    canManageOthersSlashCommands: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /**
        * The function to call when Regenerate Token link is clicked
        */
        regenCommandToken: _propTypes2.default.func.isRequired,

        /**
        * The function to call when Delete link is clicked
        */
        deleteCommand: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = InstalledCommands;

/***/ }),

/***/ 1937:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _delete_integration = __webpack_require__(966);

var _delete_integration2 = _interopRequireDefault(_delete_integration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstalledCommand = function (_React$PureComponent) {
    (0, _inherits3.default)(InstalledCommand, _React$PureComponent);

    function InstalledCommand() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, InstalledCommand);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InstalledCommand.__proto__ || (0, _getPrototypeOf2.default)(InstalledCommand)).call.apply(_ref, [this].concat(args))), _this), _this.handleRegenToken = function (e) {
            e.preventDefault();

            _this.props.onRegenToken(_this.props.command);
        }, _this.handleDelete = function () {
            _this.props.onDelete(_this.props.command);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(InstalledCommand, [{
        key: 'matchesFilter',
        value: function matchesFilter(command, filter) {
            if (!filter) {
                return true;
            }

            return command.display_name.toLowerCase().indexOf(filter) !== -1 || command.description.toLowerCase().indexOf(filter) !== -1 || command.trigger.toLowerCase().indexOf(filter) !== -1;
        }
    }, {
        key: 'render',
        value: function render() {
            var command = this.props.command;
            var filter = this.props.filter ? this.props.filter.toLowerCase() : '';

            if (!this.matchesFilter(command, filter)) {
                return null;
            }

            var name = void 0;

            if (command.display_name) {
                name = command.display_name;
            } else {
                name = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_commands.unnamed_command',
                    defaultMessage: 'Unnamed Slash Command'
                });
            }

            var description = null;
            if (command.description) {
                description = _react2.default.createElement(
                    'div',
                    { className: 'item-details__row' },
                    _react2.default.createElement(
                        'span',
                        { className: 'item-details__description' },
                        command.description
                    )
                );
            }

            var trigger = '- /' + command.trigger;
            if (command.auto_complete && command.auto_complete_hint) {
                trigger += ' ' + command.auto_complete_hint;
            }

            var actions = null;
            if (this.props.canChange) {
                actions = _react2.default.createElement(
                    'div',
                    { className: 'item-actions' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'style--none color--link',
                            onClick: this.handleRegenToken
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.regenToken',
                            defaultMessage: 'Regenerate Token'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/commands/edit?id=' + command.id },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'installed_integrations.edit',
                            defaultMessage: 'Edit'
                        })
                    ),
                    ' - ',
                    _react2.default.createElement(_delete_integration2.default, {
                        messageId: 'installed_commands.delete.confirm',
                        onDelete: this.handleDelete
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-list__item' },
                _react2.default.createElement(
                    'div',
                    { className: 'item-details' },
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__name' },
                            name
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__trigger' },
                            trigger
                        )
                    ),
                    description,
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__token' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.token',
                                defaultMessage: 'Token: {token}',
                                values: {
                                    token: command.token
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'item-details__row' },
                        _react2.default.createElement(
                            'span',
                            { className: 'item-details__creation' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'installed_integrations.creation',
                                defaultMessage: 'Created by {creator} on {createAt, date, full}',
                                values: {
                                    creator: this.props.creator.username,
                                    createAt: command.create_at
                                }
                            })
                        )
                    )
                ),
                actions
            );
        }
    }]);
    return InstalledCommand;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

InstalledCommand.propTypes = {

    /**
    * The team data
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * Installed slash command to display
    */
    command: _propTypes2.default.object.isRequired,

    /**
    * The function to call when Regenerate Token link is clicked
    */
    onRegenToken: _propTypes2.default.func.isRequired,

    /**
    * The function to call when Delete link is clicked
    */
    onDelete: _propTypes2.default.func.isRequired,

    /**
    * Set to filter command, comes from BackstageList
    */
    filter: _propTypes2.default.string,

    /**
    * The creator user data
    */
    creator: _propTypes2.default.object.isRequired,

    /**
    * Set to show edit link
    */
    canChange: _propTypes2.default.bool.isRequired
};
exports.default = InstalledCommand;

/***/ }),

/***/ 1938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _add_command = __webpack_require__(1939);

var _add_command2 = _interopRequireDefault(_add_command);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            addCommand: _integrations.addCommand
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_add_command2.default);

/***/ }),

/***/ 1939:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _browser_history = __webpack_require__(273);

var _abstract_command = __webpack_require__(1307);

var _abstract_command2 = _interopRequireDefault(_abstract_command);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var HEADER = { id: 'integrations.add', defaultMessage: 'Add' };
var FOOTER = { id: 'add_command.save', defaultMessage: 'Save' };

var AddCommand = function (_React$PureComponent) {
    (0, _inherits3.default)(AddCommand, _React$PureComponent);

    function AddCommand(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, AddCommand);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddCommand.__proto__ || (0, _getPrototypeOf2.default)(AddCommand)).call(this, props));

        _this.addCommand = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(command) {
                var _ref2, data, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.setState({ serverError: '' });

                                _context.next = 3;
                                return _this.props.actions.addCommand(command);

                            case 3:
                                _ref2 = _context.sent;
                                data = _ref2.data;
                                error = _ref2.error;

                                if (!data) {
                                    _context.next = 9;
                                    break;
                                }

                                _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/commands/confirm?type=commands&id=' + data.id);
                                return _context.abrupt('return');

                            case 9:

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                }

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.state = {
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(AddCommand, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_abstract_command2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: '',
                action: this.addCommand,
                serverError: this.state.serverError
            });
        }
    }]);
    return AddCommand;
}(_react2.default.PureComponent);

AddCommand.propTypes = {

    /**
    * The team data
    */
    team: _propTypes2.default.object,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to add new command
        */
        addCommand: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AddCommand;

/***/ }),

/***/ 1940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _integrations = __webpack_require__(823);

var _integrations2 = __webpack_require__(908);

var _general = __webpack_require__(113);

var _edit_command = __webpack_require__(1941);

var _edit_command2 = _interopRequireDefault(_edit_command);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var config = (0, _general.getConfig)(state);
    var commandId = new URLSearchParams(ownProps.location.search).get('id');
    var enableCommands = config.EnableCommands === 'true';

    return {
        commandId: commandId,
        commands: (0, _integrations2.getCommands)(state),
        enableCommands: enableCommands
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getCustomTeamCommands: _integrations.getCustomTeamCommands,
            editCommand: _integrations.editCommand
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_edit_command2.default);

/***/ }),

/***/ 1941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _browser_history = __webpack_require__(273);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _abstract_command = __webpack_require__(1307);

var _abstract_command2 = _interopRequireDefault(_abstract_command);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEADER = { id: 'integrations.edit', defaultMessage: 'Edit' }; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FOOTER = { id: 'edit_command.save', defaultMessage: 'Update' };

var EditCommand = function (_React$PureComponent) {
    (0, _inherits3.default)(EditCommand, _React$PureComponent);

    function EditCommand(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, EditCommand);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EditCommand.__proto__ || (0, _getPrototypeOf2.default)(EditCommand)).call(this, props));

        _this.editCommand = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(command) {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.newCommand = command;

                                if (_this.state.originalCommand.id) {
                                    command.id = _this.state.originalCommand.id;
                                }

                                if (!(_this.state.originalCommand.url !== _this.newCommand.url || _this.state.originalCommand.trigger !== _this.newCommand.trigger || _this.state.originalCommand.method !== _this.newCommand.method)) {
                                    _context.next = 6;
                                    break;
                                }

                                _this.handleConfirmModal();
                                _context.next = 8;
                                break;

                            case 6:
                                _context.next = 8;
                                return _this.submitCommand();

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleConfirmModal = function () {
            _this.setState({ showConfirmModal: true });
        };

        _this.confirmModalDismissed = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.submitCommand = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            var _ref3, data, error;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _this.setState({ serverError: '' });

                            _context2.next = 3;
                            return _this.props.actions.editCommand(_this.newCommand);

                        case 3:
                            _ref3 = _context2.sent;
                            data = _ref3.data;
                            error = _ref3.error;

                            if (!data) {
                                _context2.next = 9;
                                break;
                            }

                            _browser_history.browserHistory.push('/' + _this.props.team.name + '/integrations/commands');
                            return _context2.abrupt('return');

                        case 9:

                            _this.setState({ showConfirmModal: false });

                            if (error) {
                                _this.setState({ serverError: error.message });
                            }

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        _this.renderExtra = function () {
            var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_command.update',
                defaultMessage: 'Update'
            });

            var confirmTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_command.confirm',
                defaultMessage: 'Edit Slash Command'
            });

            var confirmMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'update_command.question',
                defaultMessage: 'Your changes may break the existing slash command. Are you sure you would like to update it?'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                title: confirmTitle,
                message: confirmMessage,
                confirmButtonText: confirmButton,
                show: _this.state.showConfirmModal,
                onConfirm: _this.submitCommand,
                onCancel: _this.confirmModalDismissed
            });
        };

        _this.state = {
            originalCommand: null,
            showConfirmModal: false,
            serverError: ''
        };
        return _this;
    }

    (0, _createClass3.default)(EditCommand, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            if (this.props.enableCommands) {
                this.props.actions.getCustomTeamCommands(this.props.team.id).then(function () {
                    _this3.setState({
                        originalCommand: (0, _values2.default)(_this3.props.commands).filter(function (command) {
                            return command.id === _this3.props.commandId;
                        })[0]
                    });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.originalCommand) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(_abstract_command2.default, {
                team: this.props.team,
                header: HEADER,
                footer: FOOTER,
                renderExtra: this.renderExtra(),
                action: this.editCommand,
                serverError: this.state.serverError,
                initialCommand: this.state.originalCommand
            });
        }
    }]);
    return EditCommand;
}(_react2.default.PureComponent);

EditCommand.propTypes = {

    /**
    * The current team
    */
    team: _propTypes2.default.object.isRequired,

    /**
    * The id of the command to edit
    */
    commandId: _propTypes2.default.string.isRequired,

    /**
    * Installed slash commands to display
    */
    commands: _propTypes2.default.object,

    actions: _propTypes2.default.shape({

        /**
        * The function to call to fetch team commands
        */
        getCustomTeamCommands: _propTypes2.default.func.isRequired,

        /**
        * The function to call to edit command
        */
        editCommand: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
    * Whether or not commands are enabled.
    */
    enableCommands: _propTypes2.default.bool
};
exports.default = EditCommand;

/***/ }),

/***/ 1942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _browser_history = __webpack_require__(273);

var _integration_store = __webpack_require__(1943);

var _integration_store2 = _interopRequireDefault(_integration_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _backstage_header = __webpack_require__(907);

var _backstage_header2 = _interopRequireDefault(_backstage_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmIntegration = function (_React$Component) {
    (0, _inherits3.default)(ConfirmIntegration, _React$Component);
    (0, _createClass3.default)(ConfirmIntegration, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                team: _propTypes2.default.object,
                location: _propTypes2.default.object,
                commands: _propTypes2.default.object,
                loading: _propTypes2.default.bool
            };
        }
    }]);

    function ConfirmIntegration(props) {
        (0, _classCallCheck3.default)(this, ConfirmIntegration);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmIntegration.__proto__ || (0, _getPrototypeOf2.default)(ConfirmIntegration)).call(this, props));

        _this.handleIntegrationChange = _this.handleIntegrationChange.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);

        var userId = _user_store2.default.getCurrentId();

        _this.state = {
            type: new URLSearchParams(_this.props.location.search).get('type'),
            id: new URLSearchParams(_this.props.location.search).get('id'),
            oauthApps: _integration_store2.default.getOAuthApps(userId),
            loading: !_integration_store2.default.hasReceivedOAuthApps(userId)
        };
        return _this;
    }

    (0, _createClass3.default)(ConfirmIntegration, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _integration_store2.default.addChangeListener(this.handleIntegrationChange);
            window.addEventListener('keypress', this.handleKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _integration_store2.default.removeChangeListener(this.handleIntegrationChange);
            window.removeEventListener('keypress', this.handleKeyPress);
        }
    }, {
        key: 'handleIntegrationChange',
        value: function handleIntegrationChange() {
            var userId = _user_store2.default.getCurrentId();

            this.setState({
                oauthApps: _integration_store2.default.getOAuthApps(userId),
                loading: !_integration_store2.default.hasReceivedOAuthApps(userId)
            });
        }
    }, {
        key: 'handleKeyPress',
        value: function handleKeyPress(e) {
            if (e.key === 'Enter') {
                _browser_history.browserHistory.push('/' + this.props.team.name + '/integrations/' + this.state.type);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var headerText = null;
            var helpText = null;
            var tokenText = null;

            if (this.props.loading === true) {
                return _react2.default.createElement('div', null);
            }

            if (this.state.type === _constants2.default.Integrations.COMMAND) {
                headerText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_commands.header',
                    defaultMessage: 'Slash Commands'
                });
                helpText = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_command.doneHelp',
                        defaultMessage: 'Your slash command has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Mattermost team (see <a href="https://docs.mattermost.com/developer/slash-commands.html">documentation</a> for further details).'
                    })
                );
                tokenText = _react2.default.createElement(
                    'p',
                    { className: 'word-break--all' },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_command.token',
                        defaultMessage: '<b>Token</b>: {token}',
                        values: {
                            token: this.props.commands[this.state.id].token
                        }
                    })
                );
            } else if (this.state.type === _constants2.default.Integrations.INCOMING_WEBHOOK) {
                headerText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_incoming_webhooks.header',
                    defaultMessage: 'Incoming Webhooks'
                });
                helpText = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_incoming_webhook.doneHelp',
                        defaultMessage: 'Your incoming webhook has been set up. Please send data to the following URL (see <a href=\\"https://docs.mattermost.com/developer/webhooks-incoming.html\\">documentation</a> for further details).'
                    })
                );
                tokenText = _react2.default.createElement(
                    'p',
                    { className: 'word-break--all' },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_incoming_webhook.url',
                        defaultMessage: '<b>URL</b>: {url}',
                        values: {
                            url: window.location.origin + '/hooks/' + this.state.id
                        }
                    })
                );
            } else if (this.state.type === _constants2.default.Integrations.OUTGOING_WEBHOOK) {
                headerText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'installed_outgoing_webhooks.header',
                    defaultMessage: 'Outgoing Webhooks'
                });
                helpText = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_outgoing_webhook.doneHelp',
                        defaultMessage: 'Your outgoing webhook has been set up. The following token will be sent in the outgoing payload. Please use it to verify the request came from your Mattermost team (see <a href=\\"https://docs.mattermost.com/developer/webhooks-outgoing.html\\">documentation</a> for further details).'
                    })
                );
                tokenText = _react2.default.createElement(
                    'p',
                    { className: 'word-break--all' },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'add_outgoing_webhook.token',
                        defaultMessage: '<b>Token</b>: {token}',
                        values: {
                            token: _integration_store2.default.getOutgoingWebhook(this.props.team.id, this.state.id).token
                        }
                    })
                );
            } else if (this.state.type === _constants2.default.Integrations.OAUTH_APP) {
                var oauthApp = {};
                for (var i = 0; i < this.state.oauthApps.length; i++) {
                    if (this.state.oauthApps[i].id === this.state.id) {
                        oauthApp = this.state.oauthApps[i];
                        break;
                    }
                }

                if (oauthApp) {
                    headerText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'installed_oauth_apps.header',
                        defaultMessage: 'OAuth 2.0 Applications'
                    });

                    helpText = [];
                    helpText.push(_react2.default.createElement(
                        'p',
                        { key: 'add_oauth_app.doneHelp' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'add_oauth_app.doneHelp',
                            defaultMessage: 'Your OAuth 2.0 application has been set up. Please use the following Client ID and Client Secret when requesting authorization for your application (see <a href="https://docs.mattermost.com/developer/oauth-2-0-applications.html">documentation</a> for further details).'
                        })
                    ));
                    helpText.push(_react2.default.createElement(
                        'p',
                        { key: 'add_oauth_app.clientId' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'add_oauth_app.clientId',
                            defaultMessage: '<b>Client ID:</b> {id}',
                            values: {
                                id: this.state.id
                            }
                        }),
                        ' ',
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'add_oauth_app.clientSecret',
                            defaultMessage: '<b>Client Secret:</b> {secret}',
                            values: {
                                secret: oauthApp.client_secret
                            }
                        })
                    ));

                    helpText.push(_react2.default.createElement(
                        'p',
                        { key: 'add_oauth_app.doneUrlHelp' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'add_oauth_app.doneUrlHelp',
                            defaultMessage: 'The following are your authorized redirect URL(s).'
                        })
                    ));

                    tokenText = _react2.default.createElement(
                        'p',
                        { className: 'word-break--all' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'add_oauth_app.url',
                            defaultMessage: '<b>URL(s)</b>: {url}',
                            values: {
                                url: oauthApp.callback_urls
                            }
                        })
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content row' },
                _react2.default.createElement(
                    _backstage_header2.default,
                    null,
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/' + this.props.team.name + '/integrations/' + this.state.type },
                        headerText
                    ),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'integrations.add',
                        defaultMessage: 'Add'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-form backstage-form__confirmation' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'backstage-form__title' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'integrations.successful',
                            defaultMessage: 'Setup Successful'
                        })
                    ),
                    helpText,
                    tokenText,
                    _react2.default.createElement(
                        'div',
                        { className: 'backstage-form__footer' },
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                className: 'btn btn-primary',
                                type: 'submit',
                                to: '/' + this.props.team.name + '/integrations/' + this.state.type
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'integrations.done',
                                defaultMessage: 'Done'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return ConfirmIntegration;
}(_react2.default.Component); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ConfirmIntegration;

/***/ }),

/***/ 1943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _events = __webpack_require__(173);

var _events2 = _interopRequireDefault(_events);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var CHANGE_EVENT = 'changed';

var IntegrationStore = function (_EventEmitter) {
    (0, _inherits3.default)(IntegrationStore, _EventEmitter);

    function IntegrationStore() {
        (0, _classCallCheck3.default)(this, IntegrationStore);

        var _this = (0, _possibleConstructorReturn3.default)(this, (IntegrationStore.__proto__ || (0, _getPrototypeOf2.default)(IntegrationStore)).call(this));

        _this.entities = {};

        _redux_store2.default.subscribe(function () {
            var newEntities = _redux_store2.default.getState().entities.integrations;
            var entities = _this.entities;
            _this.entities = newEntities;

            if (newEntities !== entities) {
                _this.emitChange();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(IntegrationStore, [{
        key: 'addChangeListener',
        value: function addChangeListener(callback) {
            this.on(CHANGE_EVENT, callback);
        }
    }, {
        key: 'removeChangeListener',
        value: function removeChangeListener(callback) {
            this.removeListener(CHANGE_EVENT, callback);
        }
    }, {
        key: 'emitChange',
        value: function emitChange() {
            this.emit(CHANGE_EVENT);
        }
    }, {
        key: 'hasReceivedIncomingWebhooks',
        value: function hasReceivedIncomingWebhooks(teamId) {
            var hooks = _redux_store2.default.getState().entities.integrations.incomingHooks || {};

            var hasTeam = false;
            (0, _values2.default)(hooks).forEach(function (hook) {
                if (hook.team_id === teamId) {
                    hasTeam = true;
                }
            });

            return hasTeam;
        }
    }, {
        key: 'getIncomingWebhooks',
        value: function getIncomingWebhooks(teamId) {
            var hooks = _redux_store2.default.getState().entities.integrations.incomingHooks;

            var teamHooks = [];
            (0, _values2.default)(hooks).forEach(function (hook) {
                if (hook.team_id === teamId) {
                    teamHooks.push(hook);
                }
            });

            return teamHooks;
        }
    }, {
        key: 'hasReceivedOutgoingWebhooks',
        value: function hasReceivedOutgoingWebhooks(teamId) {
            var hooks = _redux_store2.default.getState().entities.integrations.outgoingHooks;

            var hasTeam = false;
            (0, _values2.default)(hooks).forEach(function (hook) {
                if (hook.team_id === teamId) {
                    hasTeam = true;
                }
            });

            return hasTeam;
        }
    }, {
        key: 'getOutgoingWebhooks',
        value: function getOutgoingWebhooks(teamId) {
            var hooks = _redux_store2.default.getState().entities.integrations.outgoingHooks;

            var teamHooks = [];
            (0, _values2.default)(hooks).forEach(function (hook) {
                if (hook.team_id === teamId) {
                    teamHooks.push(hook);
                }
            });

            return teamHooks;
        }
    }, {
        key: 'getOutgoingWebhook',
        value: function getOutgoingWebhook(teamId, id) {
            return _redux_store2.default.getState().entities.integrations.outgoingHooks[id];
        }
    }, {
        key: 'hasReceivedOAuthApps',
        value: function hasReceivedOAuthApps() {
            return (0, _keys2.default)(_redux_store2.default.getState().entities.integrations.oauthApps).length > 0;
        }
    }, {
        key: 'getOAuthApps',
        value: function getOAuthApps() {
            return (0, _values2.default)(_redux_store2.default.getState().entities.integrations.oauthApps);
        }
    }]);
    return IntegrationStore;
}(_events2.default);

exports.default = new IntegrationStore();

/***/ }),

/***/ 1944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

var _team_permission_gate = __webpack_require__(864);

var _team_permission_gate2 = _interopRequireDefault(_team_permission_gate);

var _backstage_category = __webpack_require__(1945);

var _backstage_category2 = _interopRequireDefault(_backstage_category);

var _backstage_section = __webpack_require__(1946);

var _backstage_section2 = _interopRequireDefault(_backstage_section);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageSidebar = function (_React$Component) {
    (0, _inherits3.default)(BackstageSidebar, _React$Component);

    function BackstageSidebar() {
        (0, _classCallCheck3.default)(this, BackstageSidebar);
        return (0, _possibleConstructorReturn3.default)(this, (BackstageSidebar.__proto__ || (0, _getPrototypeOf2.default)(BackstageSidebar)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackstageSidebar, [{
        key: 'renderCustomEmoji',
        value: function renderCustomEmoji() {
            if (!this.props.enableCustomEmoji || !Utils.canCreateCustomEmoji(this.props.user)) {
                return null;
            }

            return _react2.default.createElement(_backstage_category2.default, {
                name: 'emoji',
                parentLink: '/' + this.props.team.name,
                icon: 'fa-smile-o',
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'backstage_sidebar.emoji',
                    defaultMessage: 'Custom Emoji'
                })
            });
        }
    }, {
        key: 'renderIntegrations',
        value: function renderIntegrations() {
            if (!this.props.enableIncomingWebhooks && !this.props.enableOutgoingWebhooks && !this.props.enableCommands && !this.props.enableOAuthServiceProvider) {
                return null;
            }

            var incomingWebhooks = null;
            if (this.props.enableIncomingWebhooks) {
                incomingWebhooks = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        permissions: [_constants.Permissions.MANAGE_WEBHOOKS],
                        teamId: this.props.team.id
                    },
                    _react2.default.createElement(_backstage_section2.default, {
                        name: 'incoming_webhooks',
                        parentLink: '/' + this.props.team.name + '/integrations',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_sidebar.integrations.incoming_webhooks',
                            defaultMessage: 'Incoming Webhooks'
                        })
                    })
                );
            }

            var outgoingWebhooks = null;
            if (this.props.enableOutgoingWebhooks) {
                outgoingWebhooks = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        permissions: [_constants.Permissions.MANAGE_WEBHOOKS],
                        teamId: this.props.team.id
                    },
                    _react2.default.createElement(_backstage_section2.default, {
                        name: 'outgoing_webhooks',
                        parentLink: '/' + this.props.team.name + '/integrations',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_sidebar.integrations.outgoing_webhooks',
                            defaultMessage: 'Outgoing Webhooks'
                        })
                    })
                );
            }

            var commands = null;
            if (this.props.enableCommands) {
                commands = _react2.default.createElement(
                    _team_permission_gate2.default,
                    {
                        permissions: [_constants.Permissions.MANAGE_SLASH_COMMANDS],
                        teamId: this.props.team.id
                    },
                    _react2.default.createElement(_backstage_section2.default, {
                        name: 'commands',
                        parentLink: '/' + this.props.team.name + '/integrations',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_sidebar.integrations.commands',
                            defaultMessage: 'Slash Commands'
                        })
                    })
                );
            }

            var oauthApps = null;
            if (this.props.enableOAuthServiceProvider) {
                oauthApps = _react2.default.createElement(
                    _system_permission_gate2.default,
                    { permissions: [_constants.Permissions.MANAGE_OAUTH] },
                    _react2.default.createElement(_backstage_section2.default, {
                        name: 'oauth2-apps',
                        parentLink: '/' + this.props.team.name + '/integrations',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_sidebar.integrations.oauthApps',
                            defaultMessage: 'OAuth 2.0 Applications'
                        })
                    })
                );
            }

            return _react2.default.createElement(
                _team_permission_gate2.default,
                {
                    permissions: [_constants.Permissions.MANAGE_WEBHOOKS, _constants.Permissions.MANAGE_SLASH_COMMANDS, _constants.Permissions.MANAGE_OAUTH],
                    teamId: this.props.team.id
                },
                _react2.default.createElement(
                    _backstage_category2.default,
                    {
                        name: 'integrations',
                        icon: 'fa-link',
                        parentLink: '/' + this.props.team.name,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_sidebar.integrations',
                            defaultMessage: 'Integrations'
                        })
                    },
                    incomingWebhooks,
                    outgoingWebhooks,
                    commands,
                    oauthApps
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'backstage-sidebar' },
                _react2.default.createElement(
                    'ul',
                    null,
                    this.renderCustomEmoji(),
                    this.renderIntegrations()
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                team: _propTypes2.default.object.isRequired,
                user: _propTypes2.default.object.isRequired,
                enableCustomEmoji: _propTypes2.default.bool.isRequired,
                enableIncomingWebhooks: _propTypes2.default.bool.isRequired,
                enableOutgoingWebhooks: _propTypes2.default.bool.isRequired,
                enableCommands: _propTypes2.default.bool.isRequired,
                enableOAuthServiceProvider: _propTypes2.default.bool.isRequired
            };
        }
    }]);
    return BackstageSidebar;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = BackstageSidebar;

/***/ }),

/***/ 1945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageCategory = function (_React$Component) {
    (0, _inherits3.default)(BackstageCategory, _React$Component);

    function BackstageCategory() {
        (0, _classCallCheck3.default)(this, BackstageCategory);
        return (0, _possibleConstructorReturn3.default)(this, (BackstageCategory.__proto__ || (0, _getPrototypeOf2.default)(BackstageCategory)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackstageCategory, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                title = _props.title,
                icon = _props.icon,
                parentLink = _props.parentLink,
                children = _props.children;


            var link = parentLink + '/' + name;

            return _react2.default.createElement(
                'li',
                { className: 'backstage-sidebar__category' },
                _react2.default.createElement(
                    _reactRouterDom.NavLink,
                    {
                        to: link,
                        className: 'category-title',
                        activeClassName: 'category-title--active'
                    },
                    _react2.default.createElement('i', { className: 'fa ' + icon }),
                    _react2.default.createElement(
                        'span',
                        { className: 'category-title__text' },
                        title
                    )
                ),
                _react2.default.createElement(_reactRouterDom.Route, {
                    path: link,
                    render: function render() {
                        return _react2.default.createElement(
                            'ul',
                            { className: 'sections' },
                            _react2.default.Children.map(children, function (child) {
                                if (!child) {
                                    return child;
                                }

                                return _react2.default.cloneElement(child, {
                                    parentLink: link
                                });
                            })
                        );
                    }
                })
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                name: _propTypes2.default.string.isRequired,
                title: _propTypes2.default.node.isRequired,
                icon: _propTypes2.default.string.isRequired,
                parentLink: _propTypes2.default.string,
                children: _propTypes2.default.arrayOf(_propTypes2.default.element)
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                parentLink: '',
                children: []
            };
        }
    }, {
        key: 'contextTypes',
        get: function get() {
            return {
                router: _propTypes2.default.object.isRequired
            };
        }
    }]);
    return BackstageCategory;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = BackstageCategory;

/***/ }),

/***/ 1946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageSection = function (_React$Component) {
    (0, _inherits3.default)(BackstageSection, _React$Component);

    function BackstageSection() {
        (0, _classCallCheck3.default)(this, BackstageSection);
        return (0, _possibleConstructorReturn3.default)(this, (BackstageSection.__proto__ || (0, _getPrototypeOf2.default)(BackstageSection)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackstageSection, [{
        key: 'getLink',
        value: function getLink() {
            return this.props.parentLink + '/' + this.props.name;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                subsection = _props.subsection,
                children = _props.children;


            var link = this.getLink();

            var clonedChildren = null;
            if (children.length > 0) {
                clonedChildren = _react2.default.createElement(
                    'ul',
                    { className: 'subsections' },
                    _react2.default.Children.map(children, function (child) {
                        return _react2.default.cloneElement(child, {
                            parentLink: link,
                            subsection: true
                        });
                    })
                );
            }

            var className = 'section';
            if (subsection) {
                className = 'subsection';
            }

            return _react2.default.createElement(
                'li',
                { className: className },
                _react2.default.createElement(
                    _reactRouterDom.NavLink,
                    {
                        className: className + '-title',
                        activeClassName: className + '-title--active',
                        to: link
                    },
                    _react2.default.createElement(
                        'span',
                        { className: className + '-title__text' },
                        title
                    )
                ),
                clonedChildren
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                name: _propTypes2.default.string.isRequired,
                title: _propTypes2.default.node.isRequired,
                parentLink: _propTypes2.default.string,
                subsection: _propTypes2.default.bool,
                children: _propTypes2.default.arrayOf(_propTypes2.default.element)
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                parentLink: '',
                subsection: false,
                children: []
            };
        }
    }, {
        key: 'contextTypes',
        get: function get() {
            return {
                router: _propTypes2.default.object.isRequired
            };
        }
    }]);
    return BackstageSection;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = BackstageSection;

/***/ }),

/***/ 1947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _constants = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageNavbar = function (_React$Component) {
    (0, _inherits3.default)(BackstageNavbar, _React$Component);

    function BackstageNavbar() {
        (0, _classCallCheck3.default)(this, BackstageNavbar);
        return (0, _possibleConstructorReturn3.default)(this, (BackstageNavbar.__proto__ || (0, _getPrototypeOf2.default)(BackstageNavbar)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackstageNavbar, [{
        key: 'render',
        value: function render() {
            if (!this.props.team) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-navbar' },
                _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: 'backstage-navbar__back',
                        to: '/' + this.props.team.name + '/channels/' + _constants.Constants.DEFAULT_CHANNEL
                    },
                    _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'backstage_navbar.backToMattermost',
                            defaultMessage: 'Back to {siteName}',
                            values: {
                                siteName: this.props.siteName
                            }
                        })
                    )
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                team: _propTypes2.default.object.isRequired,
                siteName: _propTypes2.default.string
            };
        }
    }]);
    return BackstageNavbar;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = BackstageNavbar;

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BackstageHeader = function (_React$Component) {
    (0, _inherits3.default)(BackstageHeader, _React$Component);

    function BackstageHeader() {
        (0, _classCallCheck3.default)(this, BackstageHeader);
        return (0, _possibleConstructorReturn3.default)(this, (BackstageHeader.__proto__ || (0, _getPrototypeOf2.default)(BackstageHeader)).apply(this, arguments));
    }

    (0, _createClass3.default)(BackstageHeader, [{
        key: 'render',
        value: function render() {
            var children = [];

            _react2.default.Children.forEach(this.props.children, function (child, index) {
                if (index !== 0) {
                    children.push(_react2.default.createElement(
                        'span',
                        {
                            key: 'divider' + index,
                            className: 'backstage-header__divider'
                        },
                        _react2.default.createElement('i', { className: 'fa fa-angle-right' })
                    ));
                }

                children.push(child);
            });

            return _react2.default.createElement(
                'div',
                { className: 'backstage-header' },
                _react2.default.createElement(
                    'h1',
                    null,
                    children
                )
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                children: _propTypes2.default.node
            };
        }
    }]);
    return BackstageHeader;
}(_react2.default.Component);

exports.default = BackstageHeader;

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAutocompleteCommandsList = exports.getAllCommands = exports.getOutgoingHooksInCurrentTeam = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.getIncomingHooks = getIncomingHooks;
exports.getOutgoingHooks = getOutgoingHooks;
exports.getCommands = getCommands;
exports.getOAuthApps = getOAuthApps;
exports.getSystemCommands = getSystemCommands;

var _reselect = __webpack_require__(78);

var _teams = __webpack_require__(274);

function getIncomingHooks(state) {
    return state.entities.integrations.incomingHooks;
}

function getOutgoingHooks(state) {
    return state.entities.integrations.outgoingHooks;
}

function getCommands(state) {
    return state.entities.integrations.commands;
}

function getOAuthApps(state) {
    return state.entities.integrations.oauthApps;
}

function getSystemCommands(state) {
    return state.entities.integrations.systemCommands;
}

/**
 * get outgoing hooks in current team
 */
var getOutgoingHooksInCurrentTeam = exports.getOutgoingHooksInCurrentTeam = (0, _reselect.createSelector)(_teams.getCurrentTeamId, getOutgoingHooks, function (teamId, hooks) {
    return Object.values(hooks).filter(function (o) {
        return o.teamId === teamId;
    });
});

var getAllCommands = exports.getAllCommands = (0, _reselect.createSelector)(getCommands, getSystemCommands, function (commands, systemCommands) {
    return _extends({}, commands, systemCommands);
});

var getAutocompleteCommandsList = exports.getAutocompleteCommandsList = (0, _reselect.createSelector)(getAllCommands, _teams.getCurrentTeamId, function (commands, currentTeamId) {
    return Object.values(commands).filter(function (command) {
        return command && (!command.team_id || command.team_id === currentTeamId) && command.auto_complete;
    }).sort(function (a, b) {
        return a.display_name.localeCompare(b.display_name);
    });
});

/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _load = __webpack_require__(865);

var _load2 = _interopRequireDefault(_load);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerButton = function (_PureComponent) {
    (0, _inherits3.default)(SpinnerButton, _PureComponent);

    function SpinnerButton() {
        (0, _classCallCheck3.default)(this, SpinnerButton);
        return (0, _possibleConstructorReturn3.default)(this, (SpinnerButton.__proto__ || (0, _getPrototypeOf2.default)(SpinnerButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(SpinnerButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                spinning = _props.spinning,
                children = _props.children,
                props = (0, _objectWithoutProperties3.default)(_props, ['spinning', 'children']); // eslint-disable-line no-use-before-define

            if (spinning) {
                return _react2.default.createElement('img', {
                    className: 'spinner-button__gif',
                    src: _load2.default
                });
            }

            return _react2.default.createElement(
                'button',
                (0, _extends3.default)({
                    className: 'btn btn-primary'
                }, props),
                children
            );
        }
    }]);
    return SpinnerButton;
}(_react.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

SpinnerButton.defaultProps = {
    spinning: false
};
SpinnerButton.propTypes = {

    /**
     * Children to show when not spinning
     */
    children: _propTypes2.default.node,

    /**
     * Set to true to spin
     */
    spinning: _propTypes2.default.bool.isRequired,

    /**
     * Callback function when button is clicked
     */
    onClick: _propTypes2.default.func
};
exports.default = SpinnerButton;

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackstageList = function (_React$Component) {
    (0, _inherits3.default)(BackstageList, _React$Component);

    function BackstageList(props) {
        (0, _classCallCheck3.default)(this, BackstageList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BackstageList.__proto__ || (0, _getPrototypeOf2.default)(BackstageList)).call(this, props));

        _this.updateFilter = _this.updateFilter.bind(_this);

        _this.state = {
            filter: ''
        };
        return _this;
    }

    (0, _createClass3.default)(BackstageList, [{
        key: 'updateFilter',
        value: function updateFilter(e) {
            this.setState({
                filter: e.target.value
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var filter = this.state.filter.toLowerCase();

            var children = void 0;
            if (this.props.loading) {
                children = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                children = _react2.default.Children.map(this.props.children, function (child) {
                    return _react2.default.cloneElement(child, { filter: filter });
                });

                if (children.length === 0 && this.props.emptyText) {
                    children = _react2.default.createElement(
                        'span',
                        { className: 'backstage-list__item backstage-list__empty' },
                        this.props.emptyText
                    );
                }
            }

            var addLink = null;
            if (this.props.addLink && this.props.addText) {
                addLink = _react2.default.createElement(
                    _reactRouterDom.Link,
                    {
                        className: 'add-link',
                        to: this.props.addLink
                    },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-primary'
                        },
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.addText
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'backstage-content' },
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-header' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        this.props.header
                    ),
                    addLink
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-filters' },
                    _react2.default.createElement(
                        'div',
                        { className: 'backstage-filter__search' },
                        _react2.default.createElement('i', { className: 'fa fa-search' }),
                        _react2.default.createElement('input', {
                            type: 'search',
                            className: 'form-control',
                            placeholder: this.props.searchPlaceholder,
                            value: this.state.filter,
                            onChange: this.updateFilter,
                            style: style.search
                        })
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'backstage-list__help' },
                    this.props.helpText
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'backstage-list' },
                    children
                )
            );
        }
    }]);
    return BackstageList;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

BackstageList.propTypes = {
    children: _propTypes2.default.node,
    header: _propTypes2.default.node.isRequired,
    addLink: _propTypes2.default.string,
    addText: _propTypes2.default.node,
    emptyText: _propTypes2.default.node,
    helpText: _propTypes2.default.node,
    loading: _propTypes2.default.bool.isRequired,
    searchPlaceholder: _propTypes2.default.string
};
BackstageList.defaultProps = {
    searchPlaceholder: Utils.localizeMessage('backstage_list.search', 'Search')
};
exports.default = BackstageList;


var style = {
    search: { flexGrow: 0, flexShrink: 0 }
};

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _delete_modal_trigger = __webpack_require__(1302);

var _delete_modal_trigger2 = _interopRequireDefault(_delete_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DeleteIntegration = function (_DeleteModalTrigger) {
    (0, _inherits3.default)(DeleteIntegration, _DeleteModalTrigger);

    function DeleteIntegration() {
        (0, _classCallCheck3.default)(this, DeleteIntegration);
        return (0, _possibleConstructorReturn3.default)(this, (DeleteIntegration.__proto__ || (0, _getPrototypeOf2.default)(DeleteIntegration)).apply(this, arguments));
    }

    (0, _createClass3.default)(DeleteIntegration, [{
        key: 'triggerTitle',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'installed_integrations.delete',
                defaultMessage: 'Delete'
            });
        }
    }, {
        key: 'modalTitle',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'integrations.delete.confirm.title',
                defaultMessage: 'Delete Integration'
            });
        }
    }, {
        key: 'modalMessage',
        get: function get() {
            return _react2.default.createElement(
                'div',
                { className: 'alert alert-warning' },
                _react2.default.createElement('i', { className: 'fa fa-warning fa-margin--right' }),
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: this.props.messageId,
                    defaultMessage: 'This action permanently deletes the integration and breaks any integrations using it. Are you sure you want to delete it?'
                })
            );
        }
    }, {
        key: 'modalConfirmButton',
        get: function get() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'integrations.delete.confirm.button',
                defaultMessage: 'Delete'
            });
        }
    }]);
    return DeleteIntegration;
}(_delete_modal_trigger2.default);

exports.default = DeleteIntegration;


DeleteIntegration.propTypes = {
    messageId: _propTypes2.default.string.isRequired,
    onDelete: _propTypes2.default.func.isRequired
};

/***/ })

});


// WEBPACK FOOTER //
// 4.fd936a223f282842a347.js